<template>
    <div>
        <link rel="icon" type="image/png" sizes="32x32" href="../../public/assets/images/favicon.png">
        <link rel="stylesheet" href="../../../public/vendor/customer/css/animate.css">
        <link rel="stylesheet" href="../../../public/vendor/customer/css/animate.css" type="text/css">
        <link href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900"
            rel="stylesheet">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.1/css/all.min.css">
        <link href="../../../public/vendor/customer/css/ionicons.min.css" type="text/css" rel="stylesheet">
        <link href="../../../public/vendor/customer/css/owl.carousel.min.css" type="text/css" rel="stylesheet">
        <link href="../../../public/vendor/customer/css/owl.theme.default.min.css" type="text/css" rel="stylesheet">
        <link href="../../../public/vendor/customer/css/magnific-popup.css" type="text/css" rel="stylesheet">
        <link href="../../../public/vendor/customer/css/bootstrap.min.css" type="text/css" rel="stylesheet">
        <link href="../../../public/vendor/customer/css/jquery-ui.css" type="text/css" rel="stylesheet">
        <link href="../../../public/vendor/customer/css/mCustomScrollbar.min.css" type="text/css" rel="stylesheet">
        <link href="../../../public/vendor/customer/css/select2.min.css" type="text/css" rel="stylesheet">
        <link href="https://fonts.googleapis.com/css?family=Nunito:200,600" rel="stylesheet">
        <link href="../../../public/vendor/customer/css/style.css" type="text/css" rel="stylesheet">
        <link href="../../../public/vendor/customer/css/responsive.css" type="text/css" rel="stylesheet">
        <div>
            <div :class="{ 'special-header': isSpecialRoute }">
                <header v-if="showAfterLogin || true"
                    :class="[headerclass, 'new-header', 'flex-new-header', 'mobile-responsive', { Homescreen: isHomePage, LoggedIn: !showAfterLogin, 'english-header': selectedLanguage === 'en', 'manage-properties-hidden': !(showManageProperties && showAfterLogin), 'booking-hidden-header': !(showbooking && !isAddPropertyRoute && showAfterLogin) }]"
                    :style="{ opacity: isHeaderReady ? 1 : 0, transition: 'opacity 0.3s ease-in-out' }">
                    <div class="header-top before_login_search">
                        <div class="top-head">
                            <div class="container">
                                <b-navbar toggleable="lg">
                                    <div class="location-icon" @click="toggleCenterTabClass">
                                        <span>
                                            <svg style="width: 21px;" xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 512 512">
                                                <path
                                                    d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                                            </svg>
                                        </span>
                                    </div>
                                    <b-navbar-brand href="/">
                                        <img src="../../public/assets/images/cheapcomfort-logo.svg" alt="cheapcomfort">
                                    </b-navbar-brand>
                                    <div class="languages-icons d-none d-sm-block" id="nav-collapse" is-nav>
                                        <b-navbar-nav>
                                            <b-nav-item>
                                                <div class="icon-list-info" style="display:inline-block;">
                                                    <b-link v-b-modal.modal-2
                                                        style="text-decoration: none; cursor: pointer;">
                                                        <span class="langiage-btn">
                                                            <img :src="selectedFlagIcon" alt="Selected Language">
                                                        </span>
                                                    </b-link>
                                                </div>
                                            </b-nav-item>
                                            <b-nav-item>
                                                <div class="icon-list-info" style="display:inline-block;">
                                                    <b-link v-b-modal.modal-3
                                                        style="text-decoration: none; cursor: pointer;">
                                                        <span class="langiage-btn">
                                                            <span
                                                                style="padding: 0px; color: black; font-size: 16px; margin-bottom: 0px;">
                                                                {{ currentcurrency ? currentcurrency : 'USD' }}
                                                            </span>
                                                        </span>
                                                    </b-link>
                                                </div>
                                            </b-nav-item>
                                            <b-nav-item v-if="hidehomepage">
                                                <div class="icon-list-info icon-list-info-star"
                                                    style="display:inline-block;">
                                                    <span v-if="!hideHeader" @click="toggleFavorite">
                                                        <i :class="[isFavorited ? 'fas fa-star' : 'far fa-star']"
                                                            aria-hidden="true"></i>
                                                    </span>
                                                </div>
                                                <b-dropdown v-if="favoriteProperties.length" ref="dropdown" right>
                                                    <template v-slot:button-content>
                                                        <img :src="favoriteProperties[0].photos[0].path"
                                                            alt="Property Image" width="50" />
                                                    </template>
                                                    <b-dropdown-item v-for="property in favoriteProperties"
                                                        :key="property.id">
                                                        <img :src="property.photos[0].path" alt="Property Image"
                                                            width="50" />
                                                        <span>{{ property.city }}, {{ property.state }}</span>
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </b-nav-item>
                                            <b-nav-item v-if="!hidehomepage">
                                                <div class="icon-list-info" style="display:inline-block;">
                                                    <router-link to="/">
                                                        <span>
                                                            <i class="fa fa-home" aria-hidden="true"></i>
                                                        </span>
                                                    </router-link>
                                                </div>
                                            </b-nav-item>

                                        </b-navbar-nav>
                                    </div>
                                    <div class="center-tabs-layout" id="main_bar" v-if="!hideHeader"
                                        ref="centerTabsLayout" :class="{ 'custom-toggle-class': centerTabActive }">
                                        <b-card no-body>
                                            <b-tabs pills>
                                                <b-tab id="__BVID__15" @click="handleTabClick"
                                                    :class="{ 'active': isTabActive, 'd-none': isFirstTime && !isTabActive }">
                                                    <template #title>
                                                        <div class="title-content">
                                                            <div class="title-col"><i class="fas fa-map-marker-alt"></i>
                                                            </div>
                                                            <div class="title-col">
                                                                <small>{{ $t('property_detail.Destination') }}</small>
                                                                <p>{{ formattedLocation ||
                                                                    $t('property_detail.search_destination') }}</p>
                                                                <i v-if="searchQuery"
                                                                    class="fa fa-times-circle position-absolute"
                                                                    @click="clearSearch"
                                                                    style="top: 50%; right: 10px; transform: translateY(-50%); cursor: pointer;"></i>
                                                            </div>
                                                        </div>
                                                        <div class="search-box-header d-flex align-items-center">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                            <div class="position-relative" style="width: 100%;">
                                                                <b-form-input id="type-search" type="text"
                                                                    v-model="query" style="outline: none; border: 0;"
                                                                    class="form-control" autocomplete="off"
                                                                    :placeholder="$t('property_detail.search_destination')"
                                                                    @keyup="handleKeyUp"
                                                                    @input="onInput"></b-form-input>
                                                                <i v-if="query"
                                                                    class="fa fa-times-circle position-absolute"
                                                                    @click="clearSearch"
                                                                    style="top: 50%; right: 10px; transform: translateY(-50%); cursor: pointer;"></i>
                                                                <ul v-if="suggestions.length > 0"
                                                                    class="suggestions-list">
                                                                    <li v-for="(suggestion, index) in suggestions"
                                                                        :key="index"
                                                                        @click="selectSuggestion(suggestion, $event)">
                                                                        <div>
                                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                                width="16" height="16" fill="none">
                                                                                <path fill="#676767"
                                                                                    d="M8 1C5.236 1 3 3.191 3 5.9 3 9.575 8 15 8 15s5-5.425 5-9.1C13 3.191 10.764 1 8 1M4.429 5.9c0-1.932 1.6-3.5 3.571-3.5s3.571 1.568 3.571 3.5c0 2.016-2.057 5.033-3.571 6.916C6.514 10.947 4.429 7.895 4.429 5.9">
                                                                                </path>
                                                                                <path fill="#676767"
                                                                                    d="M8 7.65c.986 0 1.786-.784 1.786-1.75S8.986 4.15 8 4.15s-1.786.784-1.786 1.75.8 1.75 1.786 1.75">
                                                                                </path>
                                                                            </svg>
                                                                        </div>
                                                                        <span>{{ suggestion.description }}</span>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <b-card-text>
                                                        <div class="pb-4 related-filter">
                                                            <div href="/" @click="exploreNearby"
                                                                class="tabs-content pt-0">
                                                                <div class="content-col">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16"
                                                                        height="16" fill="none">
                                                                        <path fill="#676767"
                                                                            d="M8 1.333A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333m0 12A5.34 5.34 0 0 1 2.667 8 5.34 5.34 0 0 1 8 2.667 5.34 5.34 0 0 1 13.333 8 5.34 5.34 0 0 1 8 13.333m-3.667-1.666L9.34 9.34l2.327-5.007L6.66 6.66zM8 7.267c.407 0 .733.326.733.733A.73.73 0 0 1 8 8.733.73.73 0 0 1 7.267 8c0-.407.326-.733.733-.733">
                                                                        </path>
                                                                    </svg>
                                                                </div>
                                                                <div class="content-col">
                                                                    <p>{{ $t('property_detail.explore_nearby') }}</p>
                                                                    <small style="text-transform: capitalize;">{{
                                                                        $t('property_detail.find_accomodation_near_you')
                                                                    }}</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <p>{{ $t('property_detail.recent') }}</p>
                                                            <div v-for="(search, index) in reversedSearches"
                                                                :key="index" class="related-filter">
                                                                <div class="tabs-content"
                                                                    @click="handleSearchClick(search.city, search.state, search.country, search.s1date, search.e1date, search.quantity)">
                                                                    <div class="content-col">
                                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                                            width="16" height="16" fill="none">
                                                                            <path fill="#676767"
                                                                                d="M8 1C5.236 1 3 3.191 3 5.9 3 9.575 8 15 8 15s5-5.425 5-9.1C13 3.191 10.764 1 8 1M4.429 5.9c0-1.932 1.6-3.5 3.571-3.5s3.571 1.568 3.571 3.5c0 2.016-2.057 5.033-3.571 6.916C6.514 10.947 4.429 7.895 4.429 5.9">
                                                                            </path>
                                                                            <path fill="#676767"
                                                                                d="M8 7.65c.986 0 1.786-.784 1.786-1.75S8.986 4.15 8 4.15s-1.786.784-1.786 1.75.8 1.75 1.786 1.75">
                                                                            </path>
                                                                        </svg>
                                                                    </div>
                                                                    <div class="content-col">
                                                                        <p>{{ search.city }}</p>
                                                                        <small>{{ search.state }}, {{ search.country
                                                                        }}</small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </b-card-text>
                                                </b-tab>
                                                <b-tab @click="removeClass1" id="__BVID__17">
                                                    <template #title>
                                                        <div class="title-content show-title date-selector-mobile">
                                                            <div class="title-col date-picker date-field">
                                                                <div class="date-picker-wrapper">
                                                                    <date-range-picker v-model="dateRange"
                                                                        :key="localeKey" :min-date="today"
                                                                        format="format" ref="datePickerRef"
                                                                        :locale-data="locale_data"
                                                                        class="date-picker-trigger"
                                                                        @update="handleDateRangeUpdate"
                                                                        @apply="handleDateRangeApply" />
                                                                    <span class="calendar-icon">
                                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 448 512" class="icon">
                                                                            <path
                                                                                d="M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272z" />
                                                                        </svg>
                                                                    </span>
                                                                </div>

                                                            </div>
                                                            <div class="title-col ps-3">
                                                                <p>
                                                                    <span v-if="!showAddDatesText && sdate && edate">{{
                                                                        sdate }} - {{ edate
                                                                        }}</span>
                                                                    <span v-else> {{ $t('property_detail.Add_dates')
                                                                        }}</span>
                                                                </p>
                                                            </div>

                                                        </div>
                                                    </template>
                                                    <b-card-text style="display: none !important;">
                                                        <p>dd</p>
                                                    </b-card-text>
                                                </b-tab>
                                                <b-tab @click="removeClass2" id="__BVID__19">
                                                    <template #title>
                                                        <div class="title-content show-title">
                                                            <div class="title-col"><i class="fa fa-user"
                                                                    aria-hidden="true"></i>
                                                            </div>
                                                            <div class="title-col">
                                                                <small> {{ $t('property_detail.Guests') }}</small>
                                                                <p class="text-center">{{ quantity + childQuantity !=
                                                                    '0' ?
                                                                    quantity + childQuantity : '' }}</p>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <b-card-text>
                                                        <div class="guest-content">
                                                            <div class="guest-col">
                                                                <h4>{{ $t('common.adults') }}</h4>
                                                            </div>
                                                            <div class="guest-col">
                                                                <template>
                                                                    <div class="quantity">
                                                                        <b-input-group>
                                                                            <b-input-group-prepend>
                                                                                <b-btn variant="info"
                                                                                    @click="decrement()">-</b-btn>
                                                                            </b-input-group-prepend>

                                                                            <b-form-input type="number" min="0.00"
                                                                                :value="quantity !== '' ? quantity : 0"
                                                                                readonly></b-form-input>

                                                                            <b-input-group-append>
                                                                                <b-btn variant="info"
                                                                                    @click="increment()">+</b-btn>
                                                                            </b-input-group-append>
                                                                        </b-input-group>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </b-card-text>
                                                </b-tab>
                                            </b-tabs>
                                        </b-card>
                                    </div>
                                    <div class="mobile-right-toogle">
                                        <b-navbar-toggle class="nav-icon" v-if="showAfterLogin || true"
                                            target="nav-collapse1">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </b-navbar-toggle>
                                    </div>

                                    <b-collapse id="nav-collapse1" is-nav style="height: auto !important;"
                                        class="login-sidebar-items">
                                        <b-navbar-nav>
                                            <b-nav-item class="login-links"
                                                v-bind:class="(showBeforeLogin) ? 'logreg' : 'loggedin'"
                                                v-if="showBeforeLogin">
                                                <div>
                                                    <div class="hd-wrap dropdown login-link">
                                                        <span class="dropdown-toggle" id="LoginDropdown"
                                                            v-b-modal.modal-5>
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 640 512" width="24" height="24"
                                                                fill="currentColor">
                                                                <path
                                                                    d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm51.2 48h-8.3c-20.6 10.8-43.9 16-67 16s-46.4-5.2-67-16h-8.3C55.9 304 0 359.9 0 430.4C0 464.9 27.1 492 61.6 492H386.4c34.5 0 61.6-27.1 61.6-61.6C448 359.9 392.1 304 275.2 304zM632 240h-72v-72c0-13.3-10.7-24-24-24s-24 10.7-24 24v72h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h72v72c0 13.3 10.7 24 24 24s24-10.7 24-24v-72h72c13.3 0 24-10.7 24-24s-10.7-24-24-24z" />
                                                            </svg>
                                                            <span class="text-white dnon_m">{{ $t('register.sign_up')
                                                                }} </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </b-nav-item>
                                            <b-nav-item class="login-links"
                                                v-bind:class="(showBeforeLogin) ? 'logreg' : 'loggedin'"
                                                v-if="showBeforeLogin">
                                                <div>
                                                    <div class="hd-wrap dropdown login-link">
                                                        <span class="dropdown-toggle" id="LoginDropdown" role="button"
                                                            v-b-modal.modal-4>
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 512 512" width="24" height="24"
                                                                fill="currentColor">
                                                                <path
                                                                    d="M192 80c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V80zm136.4 177.4c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L274.7 240H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H274.7l-48.9 48.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80z" />
                                                            </svg>
                                                            <span class="dnon_m"> {{ $t('header.login') }}</span>
                                                        </span>
                                                    </div>

                                                </div>
                                            </b-nav-item>
                                            <b-nav-item class="login-links"
                                                v-if="showbooking && !isAddPropertyRoute && showAfterLogin">
                                                <div class="loggedin" v-if="showAfterLogin">
                                                    <div class="hd-wrap dropdown login-link">
                                                        <span class="dropdown-toggle" id="LoginDropdown" role="button"
                                                            @click="bookings()">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 640 640">
                                                                <path
                                                                    d="M424 64C437.3 64 448 74.7 448 88L448 128L480 128C515.3 128 544 156.7 544 192L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 192C96 156.7 124.7 128 160 128L192 128L192 88C192 74.7 202.7 64 216 64C229.3 64 240 74.7 240 88L240 128L400 128L400 88C400 74.7 410.7 64 424 64zM160 176C151.2 176 144 183.2 144 192L144 480C144 488.8 151.2 496 160 496L480 496C488.8 496 496 488.8 496 480L496 192C496 183.2 488.8 176 480 176L160 176zM390.7 241.9C398.5 231.2 413.5 228.8 424.2 236.6C434.9 244.4 437.3 259.4 429.5 270.1L307.4 438.1C303.3 443.8 296.9 447.4 289.9 447.9C282.9 448.4 276 445.9 271.1 441L215.2 385.1C205.8 375.7 205.8 360.5 215.2 351.2C224.6 341.9 239.8 341.8 249.1 351.2L285.1 387.2L390.7 242z" />
                                                            </svg>
                                                            <span class="dnon_m">{{ $t('property_detail.My_Bookings')
                                                                }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </b-nav-item>
                                            <!-------Language Dropdown For Mobile----------->

                                            <!---------End Language Dropdown For Mobile--------->
                                            <b-nav-item class="login-links" v-if="showAfterLogin">
                                                <div class="loggedin">
                                                    <div class="hd-wrap dropdown login-link">
                                                        <span class="dropdown-toggle" id="LoginDropdown" role="button"
                                                            @click="messages()">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 640 640">
                                                                <path
                                                                    d="M267.7 576.9C267.7 576.9 267.7 576.9 267.7 576.9L229.9 603.6C222.6 608.8 213 609.4 205 605.3C197 601.2 192 593 192 584L192 512L160 512C107 512 64 469 64 416L64 192C64 139 107 96 160 96L480 96C533 96 576 139 576 192L576 416C576 469 533 512 480 512L359.6 512L267.7 576.9zM332 472.8C340.1 467.1 349.8 464 359.7 464L480 464C506.5 464 528 442.5 528 416L528 192C528 165.5 506.5 144 480 144L160 144C133.5 144 112 165.5 112 192L112 416C112 442.5 133.5 464 160 464L216 464C226.4 464 235.3 470.6 238.6 479.9C239.5 482.4 240 485.1 240 488L240 537.7C272.7 514.6 303.3 493 331.9 472.8z" />
                                                            </svg>
                                                            <span class="dnon_m">
                                                                {{ $t('property_detail.messages') }}
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </b-nav-item>
                                            <b-nav-item v-if="showAfterLogin && hidehomepage"
                                                class="menu-img-wrap favourite-menu-item d-flex align-items-center"
                                                :class="{ active: isFavorited }" style="width: 100%;">

                                                <div class="loggedin w-full">
                                                    <div class="hd-wrap dropdown login-link">
                                                        <span class="dropdown-toggle" id="LoginDropdown" role="button"
                                                            @click="toggleFavorite()">
                                                            <div class="d-flex align-items-center justify-content-center"
                                                                style="min-width: 35px;">
                                                                <i :class="[isFavorited ? 'far fa-star' : 'far fa-star']"
                                                                    aria-hidden="true"></i>
                                                            </div>
                                                            <span class="icon-title">{{ $t('header.favourite') }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </b-nav-item>
                                            <b-nav-item class="login-links"
                                                v-show="!(isMyBookingsRoute || isAddPropertyRoute)">
                                                <div class="loggedin">
                                                    <div class="hd-wrap dropdown login-link">
                                                        <span class="dropdown-toggle" id="LoginDropdown" role="button"
                                                            v-if="isSuperAdmin" @click="goToDashboard()">
                                                            <span class="dnon_m">{{ $t('header.dashboard') }}</span>
                                                        </span>
                                                        <span class="dropdown-toggle" id="LoginDropdown" role="button"
                                                            v-else @click="Addproperty()">
                                                            <svg width="30" height="28" viewBox="0 0 30 28" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M27.5343 14.4656C27.7481 14.6527 28.0109 14.7462 28.2737 14.7462C28.581 14.7462 28.8839 14.6215 29.1066 14.3721C29.5163 13.9133 29.4762 13.2096 29.0175 12.7999L15.1701 0.466797L1.32711 12.7999C0.868355 13.2096 0.828269 13.9133 1.23803 14.3721C1.6478 14.8309 2.35153 14.871 2.81029 14.4612L3.99059 13.41V24.7499C3.99059 26.2509 5.21098 27.4668 6.70752 27.4668H22.2831C25.8819 27.4668 28.8081 24.5405 28.8081 20.9417C28.8081 18.884 27.8461 17.0489 26.354 15.8508V13.4056L27.5343 14.4567V14.4656ZM17.3882 25.2443H6.70752C6.43582 25.2443 6.21758 25.0216 6.21758 24.7543V11.428L15.1701 3.45096L24.127 11.428V14.6928C23.5435 14.5191 22.9244 14.4256 22.2831 14.4256C18.6843 14.4256 15.758 17.3518 15.758 20.9506C15.758 22.5986 16.3771 24.0996 17.3837 25.2487L17.3882 25.2443ZM26.5812 20.9506C26.5812 23.3201 24.6526 25.2487 22.2831 25.2487C19.9136 25.2487 17.985 23.3201 17.985 20.9506C17.985 18.5811 19.9136 16.6525 22.2831 16.6525C24.6526 16.6525 26.5812 18.5811 26.5812 20.9506ZM22.9556 20.2825V18.354C22.9556 17.9843 22.6572 17.6859 22.2875 17.6859C21.9178 17.6859 21.6194 17.9843 21.6194 18.354V20.2825H19.6909C19.3212 20.2825 19.0228 20.581 19.0228 20.9506C19.0228 21.3203 19.3212 21.6187 19.6909 21.6187H21.6194V23.5473C21.6194 23.917 21.9178 24.2154 22.2875 24.2154C22.6572 24.2154 22.9556 23.917 22.9556 23.5473V21.6187H24.8842C25.2539 21.6187 25.5523 21.3203 25.5523 20.9506C25.5523 20.581 25.2539 20.2825 24.8842 20.2825H22.9556Z"
                                                                    fill="white"></path>
                                                            </svg>
                                                            <span class="dnon_m">{{ $t('Side_bar.Add_Property')  
                                                                }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </b-nav-item>
                                            <b-nav-item class="login-links" v-if="showAfterLogin">
                                                <div class="loggedin" v-if="showManageProperties">
                                                    <div class="hd-wrap dropdown login-link">
                                                        <span class="dropdown-toggle" id="LoginDropdown" role="button"
                                                            @click="goToDashboard()">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 640 640">
                                                                <path
                                                                    d="M128 128C128 110.3 113.7 96 96 96C78.3 96 64 110.3 64 128L64 464C64 508.2 99.8 544 144 544L544 544C561.7 544 576 529.7 576 512C576 494.3 561.7 480 544 480L144 480C135.2 480 128 472.8 128 464L128 128zM534.6 214.6C547.1 202.1 547.1 181.8 534.6 169.3C522.1 156.8 501.8 156.8 489.3 169.3L384 274.7L326.6 217.4C314.1 204.9 293.8 204.9 281.3 217.4L185.3 313.4C172.8 325.9 172.8 346.2 185.3 358.7C197.8 371.2 218.1 371.2 230.6 358.7L304 285.3L361.4 342.7C373.9 355.2 394.2 355.2 406.7 342.7L534.7 214.7z" />
                                                            </svg>
                                                            <span class="dnon_m">{{
                                                                $t('property_detail.manage_dashboard') }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </b-nav-item>
                                            <b-nav-item v-if="showAfterLogin" class="d-flex" style="order: 2;">
                                                <b-dropdown class="profile-dropdown h-max" variant="link"
                                                    id="profile-dropdown" style="height: max-content !important;">
                                                    <template #button-content style="height: max-content !important;">
                                                        <div class="icon-list-info" style="display:inline-block;">
                                                            <span class="language-btn">
                                                                <img v-if="progileImage" :src="progileImage"
                                                                    alt="Profile"
                                                                    style="width: 40px; height: 40px; border-radius: 50px;">
                                                                <img v-else :src="userProfileImg" alt="Profile"
                                                                    style="border-radius: 50px;" class="w-30">
                                                                <span style="color: black;">{{ username.name
                                                                    }}</span>
                                                            </span>
                                                        </div>
                                                    </template>
                                                    <!-- Dropdown menu items -->
                                                    <b-dropdown-item @click="logout()">{{ $t('header.logout')
                                                    }}</b-dropdown-item>
                                                </b-dropdown>
                                            </b-nav-item>

                                            <!-------Language Dropdown For Mobile----------->
                                            <div class="languages-icons d-sm-none ml-0 mr-auto" id="nav-collapse"
                                                is-nav>
                                                <b-navbar-nav class="">
                                                    <b-nav-item>
                                                        <div class="icon-list-info" style="display:inline-block;">
                                                            <b-link v-b-modal.modal-2
                                                                style="text-decoration: none; cursor: pointer;">
                                                                <span class="langiage-btn">
                                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                                        viewBox="0 0 640 640">
                                                                        <path
                                                                            d="M192 64C209.7 64 224 78.3 224 96L224 128L352 128C369.7 128 384 142.3 384 160C384 177.7 369.7 192 352 192L342.4 192L334 215.1C317.6 260.3 292.9 301.6 261.8 337.1C276 345.9 290.8 353.7 306.2 360.6L356.6 383L418.8 243C423.9 231.4 435.4 224 448 224C460.6 224 472.1 231.4 477.2 243L605.2 531C612.4 547.2 605.1 566.1 589 573.2C572.9 580.3 553.9 573.1 546.8 557L526.8 512L369.3 512L349.3 557C342.1 573.2 323.2 580.4 307.1 573.2C291 566 283.7 547.1 290.9 531L330.7 441.5L280.3 419.1C257.3 408.9 235.3 396.7 214.5 382.7C193.2 399.9 169.9 414.9 145 427.4L110.3 444.6C94.5 452.5 75.3 446.1 67.4 430.3C59.5 414.5 65.9 395.3 81.7 387.4L116.2 370.1C132.5 361.9 148 352.4 162.6 341.8C148.8 329.1 135.8 315.4 123.7 300.9L113.6 288.7C102.3 275.1 104.1 254.9 117.7 243.6C131.3 232.3 151.5 234.1 162.8 247.7L173 259.9C184.5 273.8 197.1 286.7 210.4 298.6C237.9 268.2 259.6 232.5 273.9 193.2L274.4 192L64.1 192C46.3 192 32 177.7 32 160C32 142.3 46.3 128 64 128L160 128L160 96C160 78.3 174.3 64 192 64zM448 334.8L397.7 448L498.3 448L448 334.8z" />
                                                                    </svg>
                                                                    <img :src="selectedFlagIcon"
                                                                        alt="Selected Language">
                                                                </span>
                                                            </b-link>
                                                        </div>
                                                    </b-nav-item>
                                                    <b-nav-item>
                                                        <div class="icon-list-info" style="display:inline-block;">
                                                            <b-link v-b-modal.modal-3
                                                                style="text-decoration: none; cursor: pointer;">
                                                                <span class="langiage-btn">
                                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                                        viewBox="0 0 640 640">
                                                                        <path
                                                                            d="M192 160L192 144C192 99.8 278 64 384 64C490 64 576 99.8 576 144L576 160C576 190.6 534.7 217.2 474 230.7C471.6 227.9 469.1 225.2 466.6 222.7C451.1 207.4 431.1 195.8 410.2 187.2C368.3 169.7 313.7 160.1 256 160.1C234.1 160.1 212.7 161.5 192.2 164.2C192 162.9 192 161.5 192 160.1zM496 417L496 370.8C511.1 366.9 525.3 362.3 538.2 356.9C551.4 351.4 564.3 344.7 576 336.6L576 352C576 378.8 544.5 402.5 496 417zM496 321L496 288C496 283.5 495.6 279.2 495 275C510.5 271.1 525 266.4 538.2 260.8C551.4 255.2 564.3 248.6 576 240.5L576 255.9C576 282.7 544.5 306.4 496 320.9zM64 304L64 288C64 243.8 150 208 256 208C362 208 448 243.8 448 288L448 304C448 348.2 362 384 256 384C150 384 64 348.2 64 304zM448 400C448 444.2 362 480 256 480C150 480 64 444.2 64 400L64 384.6C75.6 392.7 88.5 399.3 101.8 404.9C143.7 422.4 198.3 432 256 432C313.7 432 368.3 422.3 410.2 404.9C423.4 399.4 436.3 392.7 448 384.6L448 400zM448 480.6L448 496C448 540.2 362 576 256 576C150 576 64 540.2 64 496L64 480.6C75.6 488.7 88.5 495.3 101.8 500.9C143.7 518.4 198.3 528 256 528C313.7 528 368.3 518.3 410.2 500.9C423.4 495.4 436.3 488.7 448 480.6z" />
                                                                    </svg>
                                                                    <span
                                                                        style="padding: 0px; color: black;font-size: 16px;margin-bottom: 0px;">{{
                                                                            currentcurrency ? currentcurrency : 'USD'
                                                                        }}</span>
                                                                </span>
                                                            </b-link>
                                                        </div>
                                                    </b-nav-item>

                                                    <b-nav-item v-if="!hidehomepage">
                                                        <div class="icon-list-info" style="display:inline-block;">
                                                            <router-link to="/">
                                                                <span>
                                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                                        viewBox="0 0 640 640">
                                                                        <path
                                                                            d="M304 70.1C313.1 61.9 326.9 61.9 336 70.1L568 278.1C577.9 286.9 578.7 302.1 569.8 312C560.9 321.9 545.8 322.7 535.9 313.8L527.9 306.6L527.9 511.9C527.9 547.2 499.2 575.9 463.9 575.9L175.9 575.9C140.6 575.9 111.9 547.2 111.9 511.9L111.9 306.6L103.9 313.8C94 322.6 78.9 321.8 70 312C61.1 302.2 62 287 71.8 278.1L304 70.1zM320 120.2L160 263.7L160 512C160 520.8 167.2 528 176 528L224 528L224 424C224 384.2 256.2 352 296 352L344 352C383.8 352 416 384.2 416 424L416 528L464 528C472.8 528 480 520.8 480 512L480 263.7L320 120.3zM272 528L368 528L368 424C368 410.7 357.3 400 344 400L296 400C282.7 400 272 410.7 272 424L272 528z" />
                                                                    </svg>
                                                                    <span>Home</span>
                                                                </span>
                                                            </router-link>
                                                        </div>
                                                    </b-nav-item>
                                                </b-navbar-nav>
                                            </div>
                                        </b-navbar-nav>
                                    </b-collapse>
                                </b-navbar>
                                <div v-if="!hideHeader">
                                    <button class="search-button d-sm-none hidden_filter"> {{ searchQuery ?? (city &&
                                        regionName && country ? city + ', ' + regionName + ', ' + country : '')
                                        }}</button>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-head new-bottom-head" v-if="!hideHeader"
                            :class="{ 'hidden_filter': seen === false }">
                            <div class="container">
                                <div class="head-list">
                                    <div class="left-head">
                                        <ul>
                                            <li>
                                                <button v-b-modal.modal-1 class="filter-btn" type="button">
                                                    <div class="flex gap-x-xs">
                                                        <i class="fa fa-sliders"></i>
                                                        <span class="text-n font-medium leading-none lg:hidden">
                                                            {{ $t('property_detail.More_filters') }}
                                                        </span>
                                                        <i class="fa fa-angle-down"></i>
                                                    </div>
                                                </button>
                                            </li>
                                            <li>
                                                <div class="switch-btn button-switcher-container">
                                                    <button v-if="showLeftArrow" @click="scrollLeft"
                                                        class="arrow left-arrow">
                                                        <i class="fa fa-angle-left" aria-hidden="true"></i>
                                                    </button>
                                                    <div class="button-switcher" ref="buttonSwitcher"
                                                        @scroll="checkScroll">
                                                        <button class="switcher" type="button"
                                                            @click="selectButton(index)"
                                                            :class="{ 'selected': index === selectedButtonIndex }"
                                                            v-show="index !== 10 && index > 2"
                                                            v-for="(button, index) in buttons" :key="index">
                                                            <div class="button-img">
                                                                <img :alt="button.alt" :src="button.src">
                                                            </div>
                                                            <span class="text-s">{{ $t(button.text) }}</span>
                                                        </button>
                                                    </div>

                                                    <button v-if="showRightArrow" @click="scrollRight"
                                                        class="arrow right-arrow">
                                                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
            <div class="menu-bar-bottom d-none">
                <div v-if="hidehomepage" class="menu-img-wrap" :class="{ active: isFavorited }"
                    @click="toggleFavorite()">
                    <b-nav-item>
                        <div class="icon-list-info icon-list-info-star" style="display:inline-block;">
                            <span>
                                <i :class="[isFavorited ? 'far fa-star' : 'far fa-star']" aria-hidden="true"></i>
                            </span>
                        </div>
                        <b-dropdown v-if="favoriteProperties.length" ref="dropdown" right>
                            <template v-slot:button-content>
                                <img :src="favoriteProperties[0].photos[0].path" alt="Property Image" width="50" />
                            </template>
                            <b-dropdown-item v-for="property in favoriteProperties" :key="property.id">
                                <img :src="property.photos[0].path" alt="Property Image" width="50" />
                                <span>{{ property.city }}, {{ property.state }}</span>
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-nav-item>
                    <span class="icon-title">{{ $t('header.favourite') }}</span>
                </div>
                <div v-if="!hidehomepage" class="menu-img-wrap" @click="redirect('/')">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                        <path
                            d="M304 70.1C313.1 61.9 326.9 61.9 336 70.1L568 278.1C577.9 286.9 578.7 302.1 569.8 312C560.9 321.9 545.8 322.7 535.9 313.8L527.9 306.6L527.9 511.9C527.9 547.2 499.2 575.9 463.9 575.9L175.9 575.9C140.6 575.9 111.9 547.2 111.9 511.9L111.9 306.6L103.9 313.8C94 322.6 78.9 321.8 70 312C61.1 302.2 62 287 71.8 278.1L304 70.1zM320 120.2L160 263.7L160 512C160 520.8 167.2 528 176 528L224 528L224 424C224 384.2 256.2 352 296 352L344 352C383.8 352 416 384.2 416 424L416 528L464 528C472.8 528 480 520.8 480 512L480 263.7L320 120.3zM272 528L368 528L368 424C368 410.7 357.3 400 344 400L296 400C282.7 400 272 410.7 272 424L272 528z" />
                    </svg>
                    <span class="icon-title">{{ $t('header.home') }}</span>
                </div>
                <div class="menu-img-wrap" @click="bookings" :class="{ active: $route.name === 'my_bookings' }">
                    <img src="../../public/assets/images/bag.svg" alt="" style="width: 24px;" />
                    <span class="icon-title">{{ $t('header.bookings') }}</span>
                </div>
                <div class="menu-img-wrap" @click="messages" :class="{ active: $route.name === 'chat' }">
                    <svg style="width: 20px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path
                            d="M160 368c26.5 0 48 21.5 48 48l0 16 72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l96 0zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-21.3 0-6.4 0-.3 0-4 0-48-48 0-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L208 492z" />
                    </svg>
                    <span class="icon-title">{{ $t('header.inbox') }}</span>
                </div>
                <div v-if="showAfterLogin" class="menu-img-wrap" :class="{ active: activeMenu === 'profile' }"
                    @click="setActiveMenu('profile')">
                    <b-nav-item class="p-0 mb-p-0">
                        <b-dropdown class="profile-dropdown" variant="link" id="profile-dropdown">
                            <!-- Dropdown toggle button with profile icon -->
                            <template #button-content>
                                <div class="icon-list-info" style="display:inline-block;">
                                    <span class="">
                                        <img v-if="progileImage" :src="progileImage" alt="Profile"
                                            style="width: 40px; height: 40px; border-radius: 50px;" />
                                        <img v-else :src="userProfileImg" alt="Profile"
                                            style="width: 24px; height: 30px; border-radius: 50px;" />
                                    </span>
                                </div>
                            </template>
                            <!-- Dropdown menu items -->
                            <b-dropdown-item @click="logout()">{{ $t("header.logout") }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-nav-item>
                    <span class="icon-title">{{ $t('header.profile') }}</span>
                </div>
            </div>
            <b-modal id="modal-5" :title="$t('register.register_title')" hide-footer ref="myModalRef">
                <div class="wrapper register-wrapper new-from-modal">
                    <div class="register-page">
                        <div class="container p-0">
                            <span class="back-button" v-if="currStep < 7">
                                <button id="bckBtn" name="bckBtn" class="pull-right" v-if="currStep > 1" @click="bckBtn"
                                    :disabled="regBusy">
                                    <i class="fa fa-angle-left"></i>
                                </button>
                                <button id="bckBtn" name="bckBtn" class="pull-left" v-else @click="redirect('/')">
                                    <i class="fa fa-angle-left"></i>
                                </button>
                            </span>
                            <div class="card card-pages">
                                <div class="form-title m-0 mb-3">
                                    <h4>{{ $t('Propertis.welcom') }}</h4>
                                </div>
                                <div class="card-body">
                                    <div class="row" v-if="regMsgTextErr != ''">
                                        <div class="col-md-12 form-group md-form">
                                            <div class="alert alert-danger">{{ regMsgTextErr }}</div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="regMsgTextSucc != ''">
                                        <div class="col-md-12 form-group md-form">
                                            <div class="alert alert-success">{{ regMsgTextSucc }}</div>
                                        </div>
                                    </div>

                                    <div class="" v-if="currStep == 1">
                                        <div class="form-group mb-3">
                                            <label for="name">{{ $t('register.name') }}</label>
                                            <input id="regFname" name="regFname"
                                                :placeholder="$t('register.enter_name')" type="text"
                                                class="form-control" autocomplete="off" v-model="regFname">
                                        </div>
                                        <div class="form-group mb-3">
                                            <label for="email">{{ $t('register.email') }}</label>
                                            <input id="regEmail" name="regEmail"
                                                :placeholder="$t('register.enter_email')" type="text"
                                                class="form-control" autocomplete="off" v-model="regEmail">
                                        </div>
                                        <div class="form-group mb-3">
                                            <label for="phone">{{ $t('register.phone') }}</label>
                                            <vue-tel-input v-model="regPhone" @update="phoneData = $event"
                                                @input="onPhoneInput"
                                                :class="{ 'is-valid': phoneObj.isValid, 'is-invalid': regPhone && !phoneObj.isValid }"
                                                :preferred-countries="['us', 'gb', 'ca']" :enable-dropdown="true"
                                                :valid-characters-only="true" :mode="'international'"
                                                :disabled-fetching-country="false" :auto-format="true"
                                                :validCharactersOnly="true" :default-country="'us'" :input-options="{
                                                    placeholder: $t('register.enter_phone'),
                                                    showDialCode: true,
                                                    tabindex: 0,
                                                }" :dropdown-options="{
                                                    showDialCodeInList: true
                                                }" :inputClasses="'form-control'" />
                                            <div v-if="regMsgTextErr && regMsgTextErr.includes('phone')"
                                                class="invalid-feedback d-block">
                                                {{ regMsgTextErr }}
                                            </div>
                                            <div v-if="phoneverifed" class="emailverified">
                                                {{ $t('register.verified_successfully') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="currStep == 1">
                                        <div class="col-md-12 form-group md-form p-0"
                                            v-if="codesent && !verifyphonenumber">
                                            <input type="text" v-model="vcode" class="form-control"
                                                :placeholder="$t('otp.enter_code')" />
                                            <div class="mt-2 mb-2">
                                                <span v-if="!otpExpired">{{ $t('otp.resend_code_in') }} <strong>{{
                                                    formattedTimer
                                                        }}</strong></span>
                                                <span v-else class="text-danger">{{ $t('otp.otp_expired') }}</span>
                                            </div>
                                            <button v-if="!otpExpired" class="btn btn-primary mt-2" @click="vrfynow">
                                                {{ $t('otp.verify_now') }}
                                            </button>
                                            <button v-else class="btn btn-secondary mt-2 ml-2" @click="sendverifycode">
                                                {{ $t('otp.resend_code') }}
                                            </button>
                                        </div>
                                        <div class="form-check">
                                            <label class="form-check-label text-muted" for="ageConfirmation">
                                                <input type="checkbox" id="ageConfirmation" name="ageConfirmation"
                                                    class="form-check-input" v-model="ageConfirmed">
                                                <div class="input-helper" style="cursor: pointer;"></div>
                                                {{ $t('form.age_confirmation') }}
                                            </label>
                                        </div>

                                        <div class="form-check">
                                            <label class="form-check-label text-muted" for="termsAndConditions">
                                                <input type="checkbox" id="termsAndConditions" name="termsAndConditions"
                                                    class="form-check-input" v-model="termsAccepted">
                                                <div class="input-helper" style="cursor: pointer;"></div>
                                                {{ $t('form.terms_and_conditions') }}
                                                <a href="/termsofservice" target="_blank">{{ $t('form.terms_of_service')
                                                    }}</a>,
                                                <a href="/privacypolicy" target="_blank">{{ $t('form.privacy_policy')
                                                    }}</a>, and
                                                <a href="/cookies-policy" target="_blank">{{ $t('form.cookies_policy')
                                                    }}</a>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="" v-if="currStep == 2">
                                        <div class="form-group mb-4">
                                            <div class="input-file">
                                                <label>{{ $t('login.password') }}</label>
                                                <div class="position-relative">
                                                    <input id="regPassword" name="regPassword" :type="type"
                                                        class="form-control" autocomplete="off" v-model="regPassword">
                                                    <div class="show-password" @click="showPassword">
                                                        <span style="color: #c7c7bd;"><i :class="btnText"></i></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group mb-4">
                                            <div class="input-file">
                                                <label>{{ $t('register.confirm_password') }}</label>
                                                <div class="position-relative">
                                                    <input id="regCpassword" name="regCpassword" :type="confirmType"
                                                        class="form-control" autocomplete="off" v-model="regCpassword">
                                                    <div class="show-password" @click="showConfirmPassword">
                                                        <span style="color: #c7c7bd;"><i
                                                                :class="btnConfirmText"></i></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-fields" v-if="currStep === 3">
                                        <div class="profile-photo-section">
                                            <div class="form-group flex-form-group"
                                                v-if="!isCameraOpen && !profilePhotoPreview">
                                                <b-form-file id="profilePhoto" v-model="profilePhoto"
                                                    @change="onProfileChange" placeholder="Upload Profile"
                                                    drop-placeholder="Upload profile" accept="image/*"></b-form-file>

                                                <div class="or-field">
                                                    <span>{{ $t('form.or') }}</span>
                                                </div>
                                                <!-- Button to open camera -->
                                                <b-button variant="outline-primary" @click="openCamera">{{
                                                    $t('form.use_camera')
                                                    }}</b-button>
                                            </div>

                                            <!-- Display video stream if camera is open -->
                                            <div class="camera-video-sec" v-if="isCameraOpen">
                                                <video ref="cameraVideo" autoplay playsinline></video>
                                                <button class="btn btn-primary" @click="captureImage">
                                                    <i class="fas fa-trash-alt"></i>{{ $t('form.capture') }}
                                                </button>
                                            </div>

                                            <!-- Display profile photo preview -->
                                            <div v-if="profilePhotoPreview" class="images-listing new-images-listing">
                                                <div class="images-card">
                                                    <div class="selected-img">
                                                        <img :src="profilePhotoPreview" alt="Profile Photo Preview"
                                                            width="200">
                                                    </div>
                                                    <button type="button" class="btn btn-primary" @click="removeImage">
                                                        <i class="fas fa-trash-alt"></i>{{ $t('form.remove') }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-fields border-0" v-if="currStep === 4">
                                        <vue-recaptcha sitekey="6Ldr4a4rAAAAAMYLDpsD5K38KA0Boa6grOSxawaR"
                                            ref="recaptchaRef" @verify="onVerify1"></vue-recaptcha>
                                    </div>

                                    <div v-if="verifyphonenumber">
                                        <div class="row mt-3" v-if="currStep < 7">
                                            <div class="col-md-6 col-6 form-group md-form">
                                                <button id="regSub" name="bckBtn" class="btn btn-primary pull-right"
                                                    @click="bckBtn" :disabled="regBusy"> {{ $t('register.back') }}
                                                </button>
                                            </div>
                                            <div class="col-md-6 col-6 form-group md-form">
                                                <button id="regSub" name="regSub" class="btn btn-primary pull-right"
                                                    @click="regSub"
                                                    :disabled="regBusy || !termsAccepted || !ageConfirmed">{{ regBtnText
                                                    }}</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="row mt-3" v-if="currStep == 1">
                                            <div class="col-md-12 form-group md-form" v-if="!codesend">
                                                <button id="regSub" name="regSub" class="btn btn-primary pull-right"
                                                    @click="sendverifycode"
                                                    :disabled="regBusy || !termsAccepted || !ageConfirmed">{{
                                                        $t('form.send_verification_code') }}
                                                </button>
                                            </div>
                                            <div class="col-md-12 form-group md-form" v-if="!verifycodenow">
                                                <button id="regSub" name="bckBtn" class="btn btn-primary pull-right"
                                                    @click="vrfynow"
                                                    :disabled="regBusy || !termsAccepted || !ageConfirmed">{{
                                                        $t('form.verify_now') }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="currStep == 7">
                                        <div class="col-md-12 form-group md-form">
                                            <button id="regSingIn" name="regSingIn" class="btn btn-primary pull-right"
                                                @click="regSingIn">{{ $t('register.sign_in') }}</button>
                                        </div>
                                    </div>
                                    <div class="social-login text-center d-sm-flex">
                                        <button class="btn px-3" @click="AuthProvider('google')">
                                            <span> <img src="../../public/assets/images/google-img.png" alt="google-img"
                                                    srcset=""> {{
                                                        $t('Propertis.login_with_google') }}</span>
                                        </button>
                                        <button class="btn px-3" @click="AuthProvider('facebook')"
                                            v-if="showSocialButtons">
                                            <span><img src="../../public/assets/images/facebook.png" alt="google-img"
                                                    srcset=""> {{
                                                        $t('Propertis.login_with_Facebook') }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-modal>
            <b-modal id="modal-6" title="Verify Now" hide-footer ref="myModalRef">
                <div class="wrapper register-wrapper">
                    <div class="register-page">
                        <div class="container p-0">
                            <span class="back-button" v-if="currStep1 < 7">
                                <button id="bckBtn" name="bckBtn" class="pull-right" v-if="currStep > 1" @click="bckBtn"
                                    :disabled="regBusy">
                                    <i class="fa fa-angle-left"></i>
                                </button>
                                <button id="bckBtn" name="bckBtn" class="pull-left" v-else @click="redirect('/')">
                                    <i class="fa fa-angle-left"></i>
                                </button>
                            </span>
                            <div class="card card-pages">
                                <div class="card-body">
                                    <div v-if="currStep1 == 1">
                                        <div class="form-title">
                                            <h4>{{ $t('form.enter_email') }}</h4>
                                        </div>
                                        <div class="row" v-if="regMsgTextErr1 != ''">
                                            <div class="col-md-12 form-group md-form">
                                                <div class="alert alert-danger">{{ regMsgTextErr1 }}</div>
                                            </div>
                                        </div>
                                        <div class="form-fields">
                                            <div class="form-group">
                                                <input id="regEmail1" name="regEmail1"
                                                    :placeholder="$t('register.email')" type="text" class="form-control"
                                                    autocomplete="off" v-model="regEmail1">
                                            </div>
                                        </div>
                                        <div class="row mt-3" v-if="currStep1 < 7">
                                            <div class="col-md-12 form-group md-form">
                                                <button id="regSub" name="regSub" class="btn btn-primary pull-right"
                                                    @click="verifybuton" :disabled="regBusy">{{ $t('form.verify_now')
                                                    }}</button>
                                            </div>
                                            <div class="col-md-12 form-group md-form" v-if="notfound">
                                                <div class="social-login text-center"> <button class="btn"
                                                        @click="createaccount1()"><i class="fa fa-user m-right-5"></i>
                                                        <span>{{
                                                            $t('login.create_account') }}</span></button></div>

                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="currStep1 == 2">
                                        <div style="padding: 10px;">
                                            <span>
                                                {{ $t('verification.sent_code') }}
                                                <span v-if="codesendagain">{{ $t('verification.again') }}</span>
                                                {{ $t('verification.enter_code') }}
                                                {{ $t('verification.expire_in') }}
                                                <span v-if="timeLeft > 0">{{ formattedTime }}</span>
                                                <span v-else>{{ $t('verification.expired') }}</span>.
                                            </span>
                                        </div>
                                        <div class="row" v-if="regMsgTextErr2 != ''">
                                            <div class="col-md-12 form-group md-form">
                                                <div class="alert alert-danger">{{ regMsgTextErr2 }}</div>
                                            </div>
                                        </div>
                                        <div class="form-fields">
                                            <div class="form-group">
                                                <div class="input-group">
                                                    <input id="verifycode" name="verifycode" type="number"
                                                        class="form-control" autocomplete="off" v-model="verifycode">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-3" v-if="currStep1 < 7">
                                            <div class="col-md-6 form-group md-form">
                                                <button id="regSub" name="regSub" class="btn btn-primary pull-right"
                                                    @click="verifynow" :disabled="regBusy">{{ $t('verification.verify')
                                                    }}</button>
                                            </div>
                                            <div class="col-md-6 form-group md-form">
                                                <button id="regSub" name="regSub" class="btn btn-primary pull-right"
                                                    @click="sendagain" :disabled="regBusy">{{
                                                        $t('verification.send_again')
                                                    }}</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row" v-if="currStep1 == 7">
                                        <div class="col-md-12 form-group md-form">
                                            <button id="regSingIn" name="regSingIn" class="btn btn-primary pull-right"
                                                @click="regSingIn">{{ $t('register.sign_in') }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-modal>
            <b-modal id="modal-4" :title="$t('login.login_title')" hide-footer ref="loginModalRef">
                <div class="wrapper register-wrapper new-from-modal">
                    <div class="login-page">
                        <div class="container p-0">
                            <div class="card card-pages">
                                <div class="card-body">
                                    <div v-if="emailverified" class="emailverified">
                                        {{ $t('login.email_verified') }}
                                    </div>
                                    <div v-if="emailnotverified" class="emailnotverified">
                                        {{ $t('login.email_not_verified') }}
                                        <a href="#" @click.prevent="verifyEmail"
                                            style="color: black; text-decoration: underline;">
                                            {{ $t('login.verify_now') }}</a>.
                                    </div>
                                    <div v-if="showError" class="alert alert-danger msg">{{ error }}</div>
                                    <div v-if="showSuccess" class="alert alert-success msg">{{ success }}</div>

                                    <form class="form-horizontal m-t-30" action="#" method="POST"
                                        v-on:submit.prevent="login">
                                        <div class="">
                                            <div class="form-group mb-4">
                                                <div class="input-file">
                                                    <label>{{ $t('login.email') }}</label>
                                                    <input class="form-control" type="text"
                                                        :placeholder="$t('login.enter_email')" autofocus
                                                        v-model="email">
                                                </div>
                                            </div>

                                            <div class="form-group mb-4">
                                                <div class="input-file">
                                                    <label>{{ $t('login.password') }}</label>
                                                    <div class="position-relative">
                                                        <input class="form-control" :type="passwordLogin"
                                                            :placeholder="$t('login.enter_password')" name="password"
                                                            autofocus v-model="password">
                                                        <img src="../../public/assets/images/show.png" alt="" srcset=""
                                                            class="show-password" @click="switchVisibility">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group row my-3 mb-4" style="justify-content: space-between;">
                                            <div class="recaptcha-div w-100">
                                                <div class="checkbox checkbox-primary  mb-2">
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input"
                                                            id="customCheck1">
                                                        <label class="custom-control-label" for="customCheck1">{{
                                                            $t('login.remember_me') }}</label>
                                                        <i class="input-helper"></i>
                                                    </div>
                                                </div>
                                                <vue-recaptcha sitekey="6Ldr4a4rAAAAAMYLDpsD5K38KA0Boa6grOSxawaR"
                                                    ref="recaptchaRef" @verify="onVerify"></vue-recaptcha>
                                            </div>
                                        </div>

                                        <div class="social-login mt-3">
                                            <div class="mb-2 d-block" style="text-align: left;">
                                                <span @click="openForgotPasswordModal"
                                                    class="text-right forgot-password-link"
                                                    style="cursor: pointer; color: #70d3ff; text-decoration: underline;">
                                                    <span>{{ $t('login.forgot_password') }}</span>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="form-group text-center m-t-20 mb-2">
                                            <div class="input-file">
                                                <button
                                                    class="btn btn-primary btn-block btn-lg waves-effect waves-light"
                                                    :class="{ disabled: isDisabled }" type="submit">{{
                                                        $t('login.login_button') }}</button>
                                            </div>
                                        </div>
                                    </form>
                                    <!-- Social Login Buttons -->
                                    <div class="social-login ">
                                        <div class="create-new-account">
                                            <span>{{ $t('login.not_registered') }}</span>
                                            <button class="btn text-center" @click="createaccount()">
                                                <span class="justify-content-center">{{ $t('login.create_account')
                                                }}</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="social-login text-center d-md-flex">
                                        <button class="btn px-3" @click="AuthProvider('google')">
                                            <span><img src="../../public/assets/images/google-img.png" alt="google-img"
                                                    srcset=""> {{
                                                        $t('Propertis.login_with_google') }}</span>
                                        </button>
                                        <button class="btn px-3" @click="AuthProvider('facebook')"
                                            v-if="showSocialButtons">
                                            <span><img src="../../public/assets/images/facebook.png" alt="facebook" srcset="">
                                                {{ $t('Propertis.login_with_Facebook') }}</span>
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-modal>
            <b-modal id="twofa-modal" v-model="show2faModal" :title="$t('twofa.verify_title')" hide-footer>
                <div class="p-2 text-center">
                    <div class="otp-container">
                        <input v-for="(box, index) in 6" :key="index" :ref="'otp' + index" maxlength="1" class="otp-box"
                            type="text" inputmode="numeric" pattern="[0-9]*" v-model="otp[index]"
                            @input="handleInput($event, index)" @keydown.backspace="handleBackspace($event, index)"
                            @paste="handlePaste($event)" />
                    </div>

                    <div class="mt-3">
                        <button class="btn btn-primary" @click="verify2FA">{{ $t('twofa.verify_button') }}</button>
                    </div>
                </div>
            </b-modal>
            <b-modal v-model="show2faSetupModal" hide-footer :title="$t('twofa.setup_title')">
                <div class="text-center new-from-modal">

                    <p>{{ $t('twofa.scan_qr') }}</p>

                    <div v-if="setupQr">
                        <!-- <div v-html="setupQr"></div> -->
                        <img :src="setupQr" alt="Google Authenticator QR" style="max-width: 220px;" />
                        <p class="mt-2">
                            {{ $t('twofa.secret') }}: <strong style="word-break: break-all;">{{ setupSecret }}</strong>
                        </p>
                    </div>

                    <div v-else class="mt-3">
                        <b-spinner small :label="$t('common.loading')"></b-spinner>
                        <p>{{ $t('twofa.generating_qr') }}</p>
                    </div>
                    <!-- 6-digit code input -->
                    <div class="form-group mt-1 mb-2">
                        <input v-model="twoFactorCodeInput" class="form-control" :placeholder="$t('twofa.enter_code')"
                            maxlength="6" inputmode="numeric" @input="sanitize2FACode" />

                        <!-- Validation message -->
                        <div v-if="twoFactorCodeError" class="twofa-invalid-feedback text-left">
                            {{ twoFactorCodeError }}
                        </div>
                        <!-- Verify Button -->
                        <button class="btn btn-primary mt-3" @click="confirmEnable2FA"
                            :disabled="is2FAEnableDisabled || verifying2FASetup">
                            <span v-if="verifying2FASetup">{{ $t('twofa.verifying') }}</span>
                            <span v-else>{{ $t('twofa.verify_enable') }}</span>
                        </button>
                    </div>
                </div>
            </b-modal>

            <b-modal id="modal-forgot-password" :title="$t('modal.reset_password_title')" hide-footer
                ref="forgotPasswordModalRef">
                <div class="wrapper register-wrapper new-from-modal">
                    <div class="forgot-password-page">
                        <div class="container p-0">
                            <div class="card card-pages border-0">
                                <div class="card-body p-0 border-0">
                                    <!-- Loading indicator -->
                                    <div class="col-md-4 col-sm-6 grid-margin stretch-card mx-auto"
                                        v-if="forgotPasswordLoading">
                                        <div class="loader-demo-box">
                                            <div class="dot-opacity-loader">
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Form content when not loading -->
                                    <div v-else>
                                        <!-- Success message -->
                                        <div v-if="forgotPasswordSuccess" class="alert alert-success mb-3">
                                            {{ forgotPasswordSuccessMessage }}
                                        </div>

                                        <!-- Error message -->
                                        <div v-if="forgotPasswordError" class="alert alert-danger mb-3">
                                            {{ forgotPasswordErrorMessage }}
                                        </div>

                                        <form @submit.prevent="sendResetEmail" v-if="!forgotPasswordSuccess">
                                            <div class="form-fields">
                                                <div class="form-group mb-4">
                                                    <div class="input-file">
                                                        <label>{{ $t('modal.email_address') }}</label>
                                                        <input id="forgot-email" type="email" class="form-control"
                                                            :placeholder="$t('modal.enter_email_placeholder')"
                                                            v-model="forgotPasswordEmail"
                                                            :class="{ 'is-invalid': forgotPasswordEmailError }"
                                                            required>
                                                        <div v-if="forgotPasswordEmailError" class="invalid-feedback">
                                                            {{ forgotPasswordEmailError }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group text-center m-t-20 mb-2 mt-3">
                                                <button type="submit"
                                                    :disabled="forgotPasswordSubmitting || !forgotPasswordEmail"
                                                    class="btn btn-primary btn-block btn-lg waves-effect waves-light">
                                                    <span v-if="forgotPasswordSubmitting">{{ $t('modal.sending')
                                                        }}...</span>
                                                    <span v-else>{{ $t('modal.send_reset_link') }}</span>
                                                </button>
                                            </div>

                                            <div class="social-login text-center">
                                                <button type="button" class="btn text-center border-0 p-0"
                                                    @click="backToLogin">
                                                    <span><i class="fas fa-angle-left"></i> {{ $t('modal.back_to_login')
                                                        }}</span>
                                                </button>
                                            </div>
                                        </form>

                                        <!-- Success state -->
                                        <div v-else class="text-center">
                                            <div class="mb-3">
                                                <i class="fas fa-check-circle text-success"
                                                    style="font-size: 3rem;"></i>
                                            </div>
                                            <p class="mb-3">{{ $t('modal.reset_link_sent') }}</p>
                                            <button type="button" class="btn btn-primary" @click="backToLogin">
                                                {{ $t('modal.back_to_login') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-modal>


            <b-modal id="modal-1" ref="modal" :title="$t('property_detail.Filter_and_sort')" hide-footer>
                <div class="filter-sort">
                    <div class="sort-sec type-place">
                        <label>{{ $t('property_detail.type_of_place') }}</label>
                        <template>
                            <b-form-radio-group v-model="selectedPropertyType" name="some-radios1"
                                @change="emitPropertyTypeFilter" class="custom-radio-group">
                                <b-form-radio value="Entire Place">{{ $t('property_detail.Entire_Place')
                                }}</b-form-radio>
                                <b-form-radio value="Shared Room">{{ $t('property_detail.Shared_Room') }}</b-form-radio>
                                <b-form-radio value="Private Room">{{ $t('property_detail.Private_Room')
                                    }}</b-form-radio>
                            </b-form-radio-group>
                        </template>
                    </div>
                    <div class="sort-sec">
                        <label>{{ $t('Propertis.Sort') }}</label>
                        <template>
                            <b-form-radio-group v-model="selected" name="some-radios" @change="emitSortOrder"
                                class="custom-radio-group">
                                <b-form-radio value="Discount">{{ $t('property_detail.discount') }}</b-form-radio>
                                <b-form-radio value="flashDiscount">{{ $t('property_detail.flash_discount')
                                    }}</b-form-radio>
                                <b-form-radio value="low-to-high">{{ $t('property_detail.low') }}</b-form-radio>
                                <b-form-radio value="high-to-low">{{ $t('property_detail.high') }}</b-form-radio>
                            </b-form-radio-group>
                        </template>

                    </div>
                    <div class="price-sec">
                        <label>{{ $t('Propertis.roms_and_spaces') }}</label>
                        <div class="room-space">
                            <div class="row m-0">
                                <div class="col-lg-12 p-0">
                                    <p>{{ $t('Propertis.Bedrooms') }}</p>
                                </div>
                                <div class="col-lg-12 p-0">
                                    <div>
                                        <b-input-group>
                                            <b-input-group-prepend>
                                                <select class="form-control" v-model="bedrooms" @change="incrementbed">
                                                    <option value="">{{ $t('property_detail.select') }}</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                </select>
                                            </b-input-group-prepend>
                                        </b-input-group>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-0">
                                <div class="col-lg-12 p-0">
                                    <p>{{ $t('Propertis.Bathroom') }}</p>
                                </div>
                                <div class="col-lg-12 p-0">
                                    <div>
                                        <b-input-group>
                                            <b-input-group-prepend>
                                                <select class="form-control" v-model="bathrooms"
                                                    @change="incrementbath">
                                                    <option value="">{{ $t('property_detail.select') }}</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                </select>
                                            </b-input-group-prepend>
                                        </b-input-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="price-sec">
                        <label>{{ $t('Propertis.popular_amenities') }}</label>
                        <b-button-group class="popularamenities-btns">
                            <b-button :class="['btn', { 'btn-primary': isKitchenActive }]"
                                style="font-size: 16px !important;" @click="toggleKitchen">
                                <span><i class="fas fa-utensils"></i></span>
                                {{ $t('Propertis.Kitchen') }}
                            </b-button>
                            <b-button :class="['btn', { 'btn-primary': isWifiActive }]"
                                style="font-size: 16px !important;" @click="toggleWifi">
                                <span><i class="fa fa-wifi" aria-hidden="true"></i></span> {{ $t('Propertis.Wifi') }}
                            </b-button>
                            <b-button :class="['btn', { 'btn-primary': isTvActive }]"
                                style="font-size: 16px !important;" @click="toggleTv">
                                <span><i class="fa fa-tv" aria-hidden="true"></i></span> {{ $t('Propertis.TV') }}
                            </b-button>
                        </b-button-group>
                    </div>

                    <div class="price-sec">
                        <label>{{ $t('property_detail.Ratings') }}</label>
                        <b-button-group class="popularamenities-btns">
                            <b-button
                                :class="{ 'btn-primary': ratingRange === 'desc', 'btn-secondary': ratingRange !== 'desc' }"
                                style="font-size: 16px !important;" @click="setratings('desc')">{{
                                    $t('property_detail.Most_to_least') }}</b-button>
                            <b-button
                                :class="{ 'btn-primary': ratingRange === 'asc', 'btn-secondary': ratingRange !== 'asc' }"
                                style="font-size: 16px !important;" @click="setratings('asc')"> {{
                                    $t('property_detail.least_to_Most') }}</b-button>
                        </b-button-group>
                    </div>
                    <div class="price-sec border-none">
                        <label>
                            {{ $t('Propertis.price_for_month') }}</label>
                        <vue-slider v-model="value_2" :min="0" :max="maxCount" :tooltip-formatter="formatCurrency"
                            @change="debouncedUpdatePriceRange"></vue-slider>
                    </div>
                </div>
                <footer class="modal-footer">
                    <button type="button" class="btn btn-light" @click="resetFilters">{{ $t('sweetalert.clear')
                        }}</button>
                    <button type="button" class="btn btn-secondary" @click="closeModal">{{ $t('sweetalert.cancel')
                        }}</button>
                    <button type="button" class="btn btn-primary" @click="filterData">{{ $t('pagination.apply')
                        }}</button>
                </footer>
            </b-modal>

            <b-modal id="modal-3" ref="myModal" size="xl" :title="$t('Propertis.Currency')" hide-footer>
                <div class="language-sec">
                    <!-- <div class="language-title border-bottom">
                        <p class="m-0 mb-4  "> {{ $t('Propertis.cur_title') }}
                        </p>
                    </div>
                    <div class="language-title">
                        <h4 class="m-0 mt-4">{{ $t('Propertis.recomend_for_you') }}</h4>
                    </div>
                    <div class="language-list border-bottom pb-3">
                        <ul>
                            <li>
                                <button type="button" class="selection-item" @click="changecurrency('USD')">
                                    <span style="color: #33333">U.S. dollar</span><br>
                                    <span style="color: #6b6b6b">USD</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" class="selection-item" @click="changecurrency('AED')">
                                    <span style="color: #33333">U.A.E. dirham</span><br>
                                    <span style="color: #6b6b6b">AED</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" class="selection-item" @click="changecurrency('SAR')">
                                    <span style="color: #33333"> Saudi Arabian riyal</span><br>
                                    <span style="color: #6b6b6b">SAR</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" class="selection-item" @click="changecurrency('GBP')">
                                    <span style="color: #33333">Pound sterling</span><br>
                                    <span style="color: #6b6b6b">GBP</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" class="selection-item" @click="changecurrency('EUR')">
                                    <span style="color: #33333">Euro</span><br>
                                    <span style="color: #6b6b6b">EUR</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div class="language-title">
                        <h4 class="m-0 mt-4">{{ $t('Propertis.all_curr') }}
                        </h4>
                    </div> -->
                    <div class="language-list">
                        <ul>
                            <li v-for="(currency, index) in currencies" :key="index">
                                <div :class="{ 'active-currency': currentcurrency === currency.currency_code }">
                                    <button type="button" class="selection-item"
                                        @click="changecurrency(currency.currency_code)">
                                        <span>{{ currency.name }}</span><br>
                                        <span>{{ currency.currency_code }}</span>
                                        <span v-if="currentcurrency === currency.currency_code" class="checkmark"><svg
                                                width="34" height="33" viewBox="0 0 34 33" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M17.072 0.185547C8.09199 0.185547 0.791992 7.48555 0.791992 16.4655C0.791992 25.4455 8.09199 32.7455 17.072 32.7455C26.052 32.7455 33.352 25.4455 33.352 16.4655C33.352 7.48555 26.042 0.185547 17.072 0.185547ZM25.072 13.3055L16.032 22.3455C15.782 22.6055 15.442 22.7455 15.072 22.7455C14.702 22.7455 14.372 22.6055 14.112 22.3455L9.08199 17.3155C8.37199 16.6055 8.32199 15.4555 8.96199 14.7455C9.31199 14.3555 9.81199 14.1355 10.322 14.1355C10.812 14.1355 11.272 14.3255 11.622 14.6755L15.062 18.1155L22.432 10.7455C22.782 10.3955 23.282 10.1855 23.792 10.1855C24.152 10.1855 24.502 10.2855 24.782 10.4755C25.242 10.7855 25.542 11.2755 25.592 11.8255C25.642 12.3755 25.452 12.9055 25.062 13.2955L25.072 13.3055Z"
                                                    fill="#70D3FF" />
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </b-modal>
            <b-modal id="modal-2" ref="myModal1" size="xl" :title="$t('Propertis.sel_your_lang')" hide-footer>
                <div class="language-sec ">
                    <div class="language-title">
                        <h4 class="m-0">{{ $t('Propertis.recomend_for_you') }}</h4>
                    </div>
                    <div class="language-list border-bottom mb-3 pb-2">
                        <ul>
                            <li>
                                <button
                                    @click="changeLanguage('en', 'https://staging.cheapcomforts.com/public/images/flag-1.png', 'USD')"
                                    type="button" class="selection-item">
                                    <p><span><img src="../../public/assets/images/flag-1.png"
                                                alt="English"></span><span>English</span></p>
                                </button>
                            </li>
                            <li>
                                <button
                                    @click="changeLanguage('es', 'https://staging.cheapcomforts.com/public/images/flag-2.png', 'EUR')"
                                    type="button" class="selection-item">
                                    <p><span><img src="../../public/assets/images/flag-2.png"
                                                alt="Spanish"></span><span>Español</span></p>
                                </button>
                            </li>
                            <li>
                                <button
                                    @click="changeLanguage('de', 'https://staging.cheapcomforts.com/public/images/flag-3.png', 'EUR')"
                                    type="button" class="selection-item">
                                    <p><span><img src="../../public/assets/images/flag-3.png"
                                                alt="German"></span><span>Deutsch</span></p>
                                </button>
                            </li>
                            <li>
                                <button
                                    @click="changeLanguage('fr', 'https://staging.cheapcomforts.com/public/images/flag-4.png', 'EUR')"
                                    type="button" class="selection-item">
                                    <p><span><img src="../../public/assets/images/flag-4.png"
                                                alt="French"></span><span>Français</span></p>
                                </button>
                            </li>
                            <li>
                                <button
                                    @click="changeLanguage('cn', 'https://staging.cheapcomforts.com/public/images/flag-5.png', 'CNY')"
                                    type="button" class="selection-item">
                                    <p><span><img src="../../public/assets/images/flag-5.png" alt="English"></span><span>
                                            简体中文</span></p>
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div class="language-title">
                        <h4 class="m-0">{{ $t('Propertis.all_lang') }}</h4>
                    </div>
                    <div class="language-list">
                        <ul>
                            <li v-for="(language, index) in this.languages" :key="index">
                                <div :class="{ 'active-currency': selectedLanguage === language.language_code }">
                                    <button
                                        @click="changeLanguage(language.language_code, 'https://staging.cheapcomforts.com/public/images/' + language.country_flag, language.currency)"
                                        type="button" class="selection-item">
                                        <p><span><img
                                                    :src="'https://staging.cheapcomforts.com/public/images/' + language.country_flag"
                                                    alt="English"></span><span>{{ language.language_name }}</span></p>
                                        <span v-if="selectedLanguage === language.language_code" class="checkmark"><svg
                                                width="34" height="33" viewBox="0 0 34 33" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M17.072 0.185547C8.09199 0.185547 0.791992 7.48555 0.791992 16.4655C0.791992 25.4455 8.09199 32.7455 17.072 32.7455C26.052 32.7455 33.352 25.4455 33.352 16.4655C33.352 7.48555 26.042 0.185547 17.072 0.185547ZM25.072 13.3055L16.032 22.3455C15.782 22.6055 15.442 22.7455 15.072 22.7455C14.702 22.7455 14.372 22.6055 14.112 22.3455L9.08199 17.3155C8.37199 16.6055 8.32199 15.4555 8.96199 14.7455C9.31199 14.3555 9.81199 14.1355 10.322 14.1355C10.812 14.1355 11.272 14.3255 11.622 14.6755L15.062 18.1155L22.432 10.7455C22.782 10.3955 23.282 10.1855 23.792 10.1855C24.152 10.1855 24.502 10.2855 24.782 10.4755C25.242 10.7855 25.542 11.2755 25.592 11.8255C25.642 12.3755 25.452 12.9055 25.062 13.2955L25.072 13.3055Z"
                                                    fill="#70D3FF" />
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { Loader } from '@googlemaps/js-api-loader';
import 'vue-suggestion/dist/vue-suggestion.css';
import DateRangePicker from 'vue2-daterange-picker';
import moment from 'moment';
import Swal from 'sweetalert2';
import _ from 'lodash';
import axios from 'axios';
import { Appurl } from '../../api';
import API from '@/api'
import { VueRecaptcha } from 'vue-recaptcha';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import vueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
    name: 'CustomerHeader',
    selectedPlace: 'any',
    components: {
        DateRangePicker,
        VueSlider,
        VueRecaptcha,
        vueTelInput
    },
    props: {
        isSpecialRoute: Boolean,
    },
    data() {
        return {
            twoFactorCodeInput: "",
            twoFactorCodeError: "",
            qrScanned: false,
            verifying2FASetup: false,
            show2faModal: false,
            show2faSetupModal: false,
            otp: ["", "", "", "", "", ""],
            tempEmail: "",
            setupQr: null,
            setupSecret: null,
            locale_data: {},
            userIp: null,
            showSocialButtons: false,
            allowedIPs: ['110.39.156.90', '202.141.226.196', '12.79.177.118'],
            localeKey: 0,
            user: JSON.parse(localStorage.getItem('user')) || {},
            recentSearches: JSON.parse(localStorage.getItem("recentSearches")) || [],
            popularCities: [],
            activeButton: 'Any Type',
            value_2: [0, 1600],
            isTabActive: false,
            isFirstTime: true,
            recaptchaToken: '',
            recaptchaToken1: '',
            cameraStream: null,
            isCameraOpen: false,
            profilePhoto: null,
            profilePhotoPreview: null,
            isLoading: true,
            isHeaderReady: false,
            isKitchenActive: false,
            isWifiActive: false,
            isTvActive: false,
            isPoolActive: false,
            selectedButtonIndex: 3,
            query: '',
            suggestions: [],
            filterPrices: [],
            placesService: null,
            isFavorited: false,
            isActive: true,
            centerTabActive: false,
            forgotPasswordEmail: '',
            forgotPasswordLoading: false,
            forgotPasswordSubmitting: false,
            forgotPasswordSuccess: false,
            forgotPasswordError: false,
            forgotPasswordSuccessMessage: '',
            forgotPasswordErrorMessage: '',
            forgotPasswordEmailError: '',
            termsAccepted: false,
            ageConfirmed: false,
            buttons: [
                { alt: 'property-image', src: `${Appurl}public/images/entireplace.png`, text: 'property_detail.Entire Place', type: 'Entire Place' },
                { alt: 'property-image', src: `${Appurl}public/images/10630058.png`, text: 'property_detail.Shared Room', type: 'Shared Room' },
                { alt: 'property-image', src: `${Appurl}public/images/10630057.png`, text: 'property_detail.Private Room', type: 'Private Room' },
                { alt: 'property-image', src: `${Appurl}public/images/all-icon.png`, text: 'property_detail.All', type: '' },
                { alt: 'property-image', src: `${Appurl}public/images/Students.png`, text: 'property_detail.students', type: 'Students' },
                { alt: 'property-image', src: `${Appurl}public/images/Temporary Workers.png`, text: 'property_detail.temporary_workers', type: 'Temporary Workers' },
                { alt: 'property-image', src: `${Appurl}public/images/Digital-Nomad.png`, text: 'property_detail.digital_nomad', type: 'Digital Nomad' },
                { alt: 'property-image', src: `${Appurl}public/images/Expatriate.png`, text: 'property_detail.expatriate', type: 'Expatriate' },
                { alt: 'property-image', src: `${Appurl}public/images/Traveler.png`, text: 'property_detail.traveler', type: 'Traveler' },
                { alt: 'property-image', src: `${Appurl}public/images/Freelancer.png`, text: 'property_detail.freelancer', type: 'Freelancer' },
                { alt: 'property-image', src: `${Appurl}public/images/Families.png`, text: 'property_detail.families', type: 'Families' },
                { alt: 'property-image', src: `${Appurl}public/images/Couples.png`, text: 'property_detail.couples', type: 'Couples' },
                { alt: 'property-image', src: `${Appurl}public/images/Others.png`, text: 'property_detail.others', type: 'Others' },

            ],
            allProperties: [],
            userLatitude: null,
            userLongitude: null,
            userCity: null,
            nearbyProperties: [],
            showLeftArrow: false,
            showRightArrow: true,
            searchPlaceholder: '',
            favoriteProperties: [],
            discountProperties: [],
            city: '',
            country: '',
            searchQuery: null,
            regionName: '',
            Authorization: '',
            selected: '',
            selectedPropertyType: '',
            selectedTargetAudience: '',
            searchText: '',
            selectedLanguage: '',
            selectedFlagIcon: 'https://staging.cheapcomforts.com/public/images/flag-1.png',
            // selectedCurrencyIcon: 'https://staging.cheapcomforts.com/public/images/currency.png',
            selectedCurrencyIcon: 'USD',
            userProfileImg: 'https://staging.cheapcomforts.com/public/simp.svg',
            showAfterLogin: false,
            showBeforeLogin: true,
            unreadNotification: 0,
            name: '',
            curroutes: null,
            dateRange: {
                startDate: moment().format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
            },
            customLocale: {
                daysOfWeek: ['M', 'T', 'W', 'T', 'F', 'S', 'S'], // Custom weekday labels
                monthNames: [
                    'January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'
                ], // Custom month names
            },
            headerclass: 'banner',
            item: {},
            items: [],
            cities: [],
            languages: [],
            currencies: [],
            quantity: '',
            childQuantity: 0,
            petQuantity: 0,
            sdate: '',
            edate: '',
            s1date: '',
            e1date: '',
            currentcurrency: 'USD',
            today: new Date(),
            priceRange: '',
            ratingRange: '',
            hideHeader: false,
            hidehomepage: false,
            showbooking: false,
            loginwithfb: false,
            progileImage: '',
            username: '',
            email: '',
            showSuccess: false,
            success: '',
            stayLogin: false,
            isDisabled: false,
            error: '',
            password: '',
            passwordLogin: "password",
            showError: false,
            repeatPassword: '',
            errorMsg: '',
            show: false,
            successShow: false,
            regBusy: false,
            notfound: false,
            regFname: '',
            regBirthday: '',
            regUsername: '',
            regPassword: '',
            regCpassword: '',
            regEmail: '',
            regEmail1: '',
            regPhone: '',
            phoneObj: {
                number: '',
                isValid: false,
                country: undefined
            },
            currStep: 1,
            currStep1: 1,
            verifycode: '',
            regMsgTextErr: '',
            regMsgTextErr1: '',
            regMsgTextErr2: '',
            regMsgTextSucc: '',
            regBtnText: this.$t('register.next'),
            type: 'password',
            confirmType: 'password',
            btnText: 'fa fa-eye',
            btnConfirmText: 'fa fa-eye',
            minPrice: 1,
            maxPrice: 1600,
            bedrooms: "",
            bathrooms: "",
            serverParams: {
                search: "",
                sort: [
                    {
                        field: 'UserID',
                        type: 'desc'
                    }
                ],
                page: 1,
                perPage: 10
            },
            showManageProperties: false,
            emailnotverified: false,
            emailverified: false,
            phoneverifed: false,
            timeLeft: 600,
            codesendagain: false,
            verifyphonenumber: false,
            codesend: false,
            verifycodenow: true,
            codesent: false,
            vcode: '',
            seen: true,
            activeMenu: 'filter',
            maxCount: 1600,
            showAddDatesText: true,
            phoneData: null,
            countdown: 600,
            timer: null,
            otpExpired: false,
            formattedTimer: '10:00',
            clickRemove: false,
        };

    },
    computed: {
        isSuperAdmin() {
            const token = localStorage.getItem('isLoggedin');
            if (!token) return false;
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (user && user.roles && user.roles.length > 0) {
                    // Assuming super admin role name is exactly 'Admin' or 'super_admin'
                    return user.roles.some(role => role.name.toLowerCase() === 'super_admin' || role.name.toLowerCase() === 'admin');
                }
                return false;
            } catch {
                return false;
            }
        },
        is2FAEnableDisabled() {
            return !/^\d{6}$/.test(this.twoFactorCodeInput);
        },
        // is2FAEnableDisabled() {
        //     return (
        //         !this.qrScanned ||
        //         this.twoFactorCodeInput.length !== 6 ||
        //         !this.setupSecret
        //     );
        // },
        reversedSearches() {
            return this.recentSearches.slice().reverse();  // Reverse a copy of the array
        },
        isHomePage() {
            return this.$route.name === "home"; // Adjust if your home route uses a different name
        },
        formattedTime() {
            const minutes = Math.floor(this.timeLeft / 60);
            const seconds = this.timeLeft % 60;
            return `${this.formatNumber(minutes)}:${this.formatNumber(seconds)}`;
        },
        isMyBookingsRoute() {
            return this.$route.path === '/my_bookings/';
        },
        isAddPropertyRoute() {
            return this.$route.path === '/add_property';
        },
        isIncomeStatisticsRoute() {
            return this.$route.path === '/income_statistics/';
        },
        formattedLocation() {
            // Return query while typing, otherwise use city, regionName, country
            if (this.query) return this.query;
            const parts = [];
            if (this.city) parts.push(this.city);
            if (this.regionName) parts.push(this.regionName);
            if (this.country) parts.push(this.country);
            return parts.join(', ') || this.searchPlaceholder || this.$t('property_detail.search_destination');
        },
        shouldShowHeader() {
            // Define routes that should hide the header
            const hideHeaderRoutes = [
                '/chat',
                '/mission',
                '/property/detail/',
                '/faq',
                '/property/rating',
                '/about-us',
                '/contact-us',
                '/my_bookings',
                '/add_property',
                '/property_details',
                '/income_statistics',
                '/property/payment',
                '/privacypolicy',
                '/cookies-policy',
                '/termsofservice',
                '/cancellation-and-refund-policy',
                '/guest-terms-and-conditions',
                '/host-terms-and-conditions',
                '/standard-contractual-clauses',
                '/data-processing-agreement',
                '/legal-disclaimer',
                '/invoice/detail/'
            ];

            return !hideHeaderRoutes.some(route => this.$route.path.startsWith(route));
        },
        isLoggedIn() {
            return !!localStorage.getItem('isLoggedin');
        },
        shouldRenderHeader() {
            return this.isHeaderReady && this.shouldShowHeader;
        }
    },
    watch: {
        show2faSetupModal(val) {
            if (val === true) {
                this.setupQr = null;        // reset
                this.setupSecret = null;
                this.twoFactorCodeInput = "";
                this.$nextTick(() => {
                    this.fetch2FASetup();   // <-- load QR NOW
                });
            }
        },
        maxCount(newVal) {
            this.value_2 = [0, newVal];
        },
        '$i18n.locale': {
            handler(newLang) {
                this.localeKey++;
                this.updateTranslations();
                // Re-format displayed dates on locale change for immediate translation
                if (this.dateRange && this.dateRange.startDate) {
                    this.sdate = this.formatDate(this.dateRange.startDate);
                }
                if (this.dateRange && this.dateRange.endDate) {
                    this.edate = this.formatDate(this.dateRange.endDate);
                }
            },
            immediate: true,
        },
        dateRange: {
            deep: true,
            handler(newVal, oldVal) {
                if (newVal === null) {
                    return;
                }
                const startMoment = moment(newVal.startDate);
                const endMoment = moment(newVal.endDate);
                this.s1date = startMoment.format('YYYY-MM-DD');
                this.e1date = endMoment.format('YYYY-MM-DD');
                // Use dynamic formatDate for translated display (e.g., "Nov 12" in EN, "11月12日" in CN)
                this.sdate = this.formatDate(startMoment.toDate());
                this.edate = this.formatDate(endMoment.toDate());

                let bed = localStorage.getItem('bed') || this.bedrooms;
                let bath = localStorage.getItem('bath') || this.bathrooms;
                let minPrice = this.minPrice;
                let maxPrice = this.maxPrice;
                let propertyType = this.selectedPropertyType;
                let targetAudience = this.selectedTargetAudience;
                let child = this.childQuantity;
                let pet = this.petQuantity;
                // this.$root.$emit('load-items', this.city, this.country, this.s1date, this.e1date);
                this.emitAllFilters();
            }
        },
        '$route': {
            handler: _.debounce(function () {
                // Update header visibility when route changes
                this.updateHeaderVisibility();
            }, 100),
            immediate: true
        }
    },
    created() {
        // Create a debounced version of updatePriceRange
        this.debouncedUpdatePriceRange = _.debounce(this.updatePriceRange, 500);
        this.debouncedFetchSuggestions = _.debounce(this.fetchSuggestions, 300);
        this.checkIPAndShowButtons();
        this.maxPerMonthPropertyPrice();
    },
    async mounted() {
        this.maxPerMonthPropertyPrice();
        this.loadRecentSearches();
        const stored = localStorage.getItem("recentSearches");
        if (stored) {
            this.recentSearches = JSON.parse(stored);
        }
        const lastSearchedLocation = localStorage.getItem('lastSearchedLocation');
        if (lastSearchedLocation) {
            this.searchQuery = lastSearchedLocation.replace(/,/g, ', ');
            const [city, state, country] = lastSearchedLocation.split(',').map(s => s.trim());
            this.city = city;
            this.regionName = state || '';
            this.country = country || '';
        }
        this.observeDatePickerPopup();
        this.loadButtonStates();
        this.setHeaderClass();
        // get location data
        let c_code;
        try {
            const ipRes = await fetch('https://api.ipify.org?format=json');
            const ipData = await ipRes.json();
            this.userIp = ipData.ip;

            const locationRes = await fetch('https://ipwho.is/' + ipData.ip);
            const locationData = await locationRes.json();

            localStorage.setItem('region', locationData.country);
            this.city = locationData.city;
            this.country = locationData.country;
            this.regionName = locationData.region;
            c_code = locationData.country_code;
            // Define your supported countries-to-language mapping
            const COUNTRY_LANGUAGE_MAP = {
                US: 'en',
                GB: 'en',
                CA: 'en',
                FR: 'fr',
                DE: 'de',
                NL: 'nl',
                IT: 'it',
                CN: 'cn',
                ES: 'es',
                AR: 'es-ar',
                MX: 'es-mx'
            };

            const alreadySelectedLanguage = localStorage.getItem('language');

            let selectedLang = alreadySelectedLanguage || COUNTRY_LANGUAGE_MAP[c_code] || 'en';

            // Save & Apply language if different
            localStorage.setItem('language', selectedLang);
            this.selectedLanguage = selectedLang;
            let flag_path = "https://www.cheapcomforts.com";
            // Map country → flag file
            const FLAG_MAP = {
                US: '/public/images/flag-1.png',
                GB: '/public/images/flag-1.png',
                CA: '/public/images/flag-1.png',
                FR: '/public/images/flag-4.png',
                DE: '/public/images/flag-3.png',
                NL: '/public/images/flag-6.png',
                IT: '/public/images/flag-10.png',
                CN: '/public/images/flag-5.png',
                ES: '/public/images/flag-2.png',
                AR: '/public/images/flag-7.png',
                MX: '/public/images/flag-8.png',
            };

            let autoFlag = FLAG_MAP[c_code] ? flag_path + FLAG_MAP[c_code] : "https://staging.cheapcomforts.com/public/images/flag-1.png";
            // Save the flag
            localStorage.setItem('flag', autoFlag);
            this.selectedFlagIcon = autoFlag;
            // Fire the existing language switch event
            this.$EventBus.$emit('changeLanguage', selectedLang);
            await new Promise((resolve, reject) => {
                API.getCities(this.country, res => {
                    this.cities = res.data.data;
                    // Populate popularCities from cities (or API)
                    this.popularCities = this.cities.slice(0, 5).map(city => ({
                        city: city.city,
                        state: city.state || '',
                        country: city.country || this.country,
                    }));
                    resolve();
                }, err => {
                    this.popularCities = [
                        { city: 'New York', state: 'NY', country: 'USA' },
                        { city: 'Los Angeles', state: 'CA', country: 'USA' },
                        { city: 'London', state: '', country: 'UK' },
                        { city: 'Paris', state: '', country: 'France' },
                        { city: 'Tokyo', state: '', country: 'Japan' },
                    ];
                    reject(err);
                });
            });
        } catch (error) {
            this.updateSearchPlaceholder('New Hanna', 'USA', 'Maryland');
            console.error('Location fetch error:', error);
        }

        // Now this block will run after location-related code
        let lang = localStorage.getItem('language');
        let flag = localStorage.getItem('flag');
        let currency = localStorage.getItem('currency');

        if (lang && flag && currency) {
            this.selectedLanguage = lang;
            this.selectedFlagIcon = flag;
            // await this.changeCurrencyMount(currency);
        } else {
            await this.fetchCurrency();
        }
        await this.fetchcountryMount(c_code);
        this.emitAllFilters();
        this.getFilterPrices();
        this.getUserProperties();

        API.getallcurriencies(res => {
            // this.currencies = res.data.data;
            this.currencies = res.data.data.filter(currency => currency.currency_code === 'USD');
        }, err => {
            console.log(err);
            this.currencies = [{ currency_code: 'USD', symbol: '$', name: 'US Dollar' }];
        });

        let fblogin = localStorage.getItem('loginwithfb');
        if (fblogin == 1) {
            this.loginwithfb = true;
        } else {
            this.loginwithfb = false;
        }
        // Initialize header visibility before setting ready state
        this.updateHeaderVisibility();
        this.updateTranslations();
        // Set header as ready to prevent flashing
        this.$nextTick(() => {
            this.isHeaderReady = true;
            if (this.dateRange && this.dateRange.startDate) {
                this.sdate = this.formatDate(this.dateRange.startDate);
            }
            if (this.dateRange && this.dateRange.endDate) {
                this.edate = this.formatDate(this.dateRange.endDate);
            }
        });

        let user = JSON.parse(localStorage.getItem("user"));
        this.loginUser = user;
        if (this.loginwithfb) {
            this.progileImage = this.loginUser.avatar
                ? `https://staging.cheapcomforts.com/public/images/${this.loginUser.avatar}`
                : null;
        }
        this.username = this.loginUser
        this.checkScroll();

        const elem = document.getElementById('__BVID__15');
        const button = document.getElementById('__BVID__15___BV_tab_button__');
        const elem1 = document.getElementById('__BVID__17');
        const button1 = document.getElementById('__BVID__17___BV_tab_button__');
        const elem2 = document.getElementById('__BVID__19');
        const button2 = document.getElementById('__BVID__19___BV_tab_button__');
        if (elem && button) {
            document.body.addEventListener('click', this.handleClickOutside);
        }
        if (elem1 && button1) {
            document.body.addEventListener('click', this.handleClickOutside);
        }
        if (elem2 && button2) {
            document.body.addEventListener('click', this.handleClickOutside);
        }
        document.body.addEventListener('click', this.handleClickOutside);
        this.Authorization = localStorage.getItem('isLoggedin');
        setTimeout(() => {
            const tabElement = document.getElementById('__BVID__15');
            const buttonElement = document.getElementById('__BVID__15___BV_tab_button__');

            if (tabElement) {
                tabElement.classList.remove("active");
            }
            if (buttonElement) {
                buttonElement.classList.remove("active");
            }
            document.getElementById('__BVID__15').classList.remove("active");
            document.getElementById('__BVID__17').classList.remove("active");
            document.getElementById('__BVID__19').classList.remove("active");
            document.getElementById('__BVID__15___BV_tab_button__').classList.remove("active");
            document.getElementById('__BVID__17___BV_tab_button__').classList.remove("active");
            document.getElementById('__BVID__19___BV_tab_button__').classList.remove("active");
        }, 100);

        if (this.Authorization !== null) {
            this.showAfterLogin = true;
            this.showBeforeLogin = false;
        } else {
            this.showBeforeLogin = true;
        }
        if (this.showAfterLogin == true) {
            API.getFavProperties(
                fevData => {
                    if (fevData.data.booking > 0) {
                        this.showbooking = true;
                    }
                });
        }
        this.loadPlacesService();
        this.$on('update-chat-widget', this.showChat);
        this.$nextTick(() => {
            this.showChat();
        });
        // emit initial nav visibility to parent layout
        this.$emit('nav-visibility', { showBooking: this.showbooking, showManage: this.showManageProperties });

        // watch for changes and notify parent so layout can update classes
        this.$watch('showbooking', (val) => {
            this.$emit('nav-visibility', { showBooking: val, showManage: this.showManageProperties });
        });
        this.$watch('showManageProperties', (val) => {
            this.$emit('nav-visibility', { showBooking: this.showbooking, showManage: val });
        });
        window.addEventListener('resize', this.showChat);
        this.maxPerMonthPropertyPrice();
    },
    beforeDestroy() {
        this.$off('update-chat-widget', this.showChat);
        document.body.removeEventListener('click', this.handleClickOutside);
        if (this.timer) clearInterval(this.timer);
        window.removeEventListener('resize', this.showChat);
        const navItems = document.querySelectorAll('.chat-widget ul.nav li.nav-item');
        navItems.forEach(item => {
            item.removeEventListener('click', this.handleNavItemClick);
        });
    },
    methods: {
       maxPerMonthPropertyPrice() {
            API.maxPerMonthPropertyPrice(
                "",
                res => {
                if (res.data && res.data.maxPerMonthPropertyPrice) {
                        this.maxPrice = res.data.maxPerMonthPropertyPrice;
                        this.value_2 = [0, this.maxPrice];
                        this.maxCount = res.data.maxPerMonthPropertyPrice;
                    }
                },
                err => {
                    // Set fallback values
                    this.maxPrice = 1600;
                    this.maxCount = 1600;
                    this.value_2 = [0, 1600];
                }
            );
        },
        sanitize2FACode() {
            // Remove anything that is NOT a digit
            this.twoFactorCodeInput = this.twoFactorCodeInput.replace(/\D/g, "").slice(0, 6);

            const len = this.twoFactorCodeInput.length;

            if (len === 0) {
                this.twoFactorCodeError = "";
            } else if (len < 6) {
                this.twoFactorCodeError = "Code must be 6 digits.";
            } else if (len === 6) {
                this.twoFactorCodeError = "";
            } else {
                this.twoFactorCodeError = "Code cannot exceed 6 digits.";
            }
        },
        checkIPAndShowButtons() {
            fetch('https://api.ipify.org?format=json')
                .then(res => res.json())
                .then(data => {
                    const currentIP = data.ip
                    if (this.allowedIPs.includes(currentIP)) {
                        this.showSocialButtons = true
                    } else {
                        this.showSocialButtons = false
                    }
                })
                .catch(err => {
                    console.error('IP detection failed:', err)
                    this.showSocialButtons = false
                })
        },
        onPhoneInput(number, phoneObject) {
            this.phoneObj = phoneObject
            this.regPhone = phoneObject.number?.international || number
        },
        validatePhone() {
            if (!this.phoneObj?.isValid) {
                this.regMsgTextErr = this.$t('validations.phone')
                return false
            }
            return true
        },
        showChat() {
            const navItems = document.querySelectorAll('.chat-widget ul.nav li.nav-item');
            const chatWidget = document.querySelector('.chat-widget');

            if (!chatWidget) {
                console.warn('chatWidget not found');
                return;
            }
            if (!navItems.length) {
                console.warn('No navItems found');
                return;
            }

            // Check if mobile or tablet (screen width <= 991px)
            const isMobileOrTablet = window.innerWidth <= 991;

            // Remove existing event listeners to prevent duplicates
            navItems.forEach(item => {
                item.removeEventListener('click', this.handleNavItemClick);
            });

            this.handleNavItemClick = (event) => {
                if (!isMobileOrTablet) return; // Skip class manipulation on desktop
                const clickedItem = event.currentTarget;
                navItems.forEach(i => i.classList.remove('active', 'inactive'));
                clickedItem.classList.add('active');
                navItems.forEach(i => {
                    if (i !== clickedItem) i.classList.add('inactive');
                });

                const tabContents = document.querySelectorAll('.tab-content');
                tabContents.forEach(tab => tab.classList.add('focus'));
            };

            navItems.forEach(item => {
                item.addEventListener('click', this.handleNavItemClick);
            });
        },
        // updateTranslations() {
        //     this.locale_data = {
        //         applyLabel: this.$t('pagination.apply'),
        //         cancelLabel: this.$t('pagination.cancel'),
        //     };
        // },
        updateTranslations() {
            // Base structure
            this.locale_data = {
                direction: 'ltr',  // Or 'rtl' for right-to-left languages like Arabic
                // format: this.format,  // Already set as 'YYYY-MM-DD'
                separator: ' - ',
                applyLabel: this.$t('pagination.apply'),  // Or your key for "Apply"
                cancelLabel: this.$t('pagination.cancel'),  // Or your key for "Cancel"
                weekLabel: this.$t('date.week_abbr'),  // e.g., 'W' or translated 'Sem'
                customRangeLabel: this.$t('date.custom_range'),  // e.g., 'Custom Range'
                firstDay: 1,  // 0=Sunday, 1=Monday (adjust per locale, e.g., 5 for Arabic)

                // Translated days (short abbreviations)
                daysOfWeek: [
                    this.$t('date.days.sunday_short'),    // e.g., 'Su' or 'dim'
                    this.$t('date.days.monday_short'),    // e.g., 'Mo' or 'lun'
                    this.$t('date.days.tuesday_short'),   // e.g., 'Tu' or 'mar'
                    this.$t('date.days.wednesday_short'), // e.g., 'We' or 'mer'
                    this.$t('date.days.thursday_short'),  // e.g., 'Th' or 'jeu'
                    this.$t('date.days.friday_short'),    // e.g., 'Fr' or 'ven'
                    this.$t('date.days.saturday_short')   // e.g., 'Sa' or 'sam'
                ],

                // Translated full month names
                monthNames: [
                    this.$t('date.months.january'),     // e.g., 'January' or 'Janvier'
                    this.$t('date.months.february'),    // e.g., 'February' or 'Février'
                    this.$t('date.months.march'),       // e.g., 'March' or 'Mars'
                    this.$t('date.months.april'),       // e.g., 'April' or 'Avril'
                    this.$t('date.months.may'),         // e.g., 'May' or 'Mai'
                    this.$t('date.months.june'),        // e.g., 'June' or 'Juin'
                    this.$t('date.months.july'),        // e.g., 'July' or 'Juillet'
                    this.$t('date.months.august'),      // e.g., 'August' or 'Août'
                    this.$t('date.months.september'),   // e.g., 'September' or 'Septembre'
                    this.$t('date.months.october'),     // e.g., 'October' or 'Octobre'
                    this.$t('date.months.november'),    // e.g., 'November' or 'Novembre'
                    this.$t('date.months.december')     // e.g., 'December' or 'Décembre'
                ]
            };
        },
        formatCurrency(value) {
            const exchangeRate = this.currencyRate || 1; // Default to 1 if not set
            const convertedValue = value * exchangeRate;
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
                // currency: this.currentcurrency || 'USD'
            }).format(convertedValue);
        },
        toggleFilter() {
            this.seen = !this.seen; // toggle active + seen together
        },
        openForgotPasswordModal() {
            // Close login modal if open
            if (this.$refs.loginModalRef) {
                this.$refs.loginModalRef.hide();
            }

            // Reset forgot password state
            this.resetForgotPasswordState();

            // Open forgot password modal
            this.$bvModal.show('modal-forgot-password');
        },

        closeForgotPasswordModal() {
            this.$refs.forgotPasswordModalRef.hide();
            this.resetForgotPasswordState();
        },
        resetForgotPasswordState() {
            this.forgotPasswordEmail = '';
            this.forgotPasswordLoading = false;
            this.forgotPasswordSubmitting = false;
            this.forgotPasswordSuccess = false;
            this.forgotPasswordError = false;
            this.forgotPasswordSuccessMessage = '';
            this.forgotPasswordErrorMessage = '';
            this.forgotPasswordEmailError = '';
        },

        validateEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        toggleCenterTabClass() {
            this.centerTabActive = !this.centerTabActive;
        },
        sendResetEmail() {
            // Reset previous errors
            this.forgotPasswordError = false;
            this.forgotPasswordEmailError = '';

            // Validate email
            if (!this.forgotPasswordEmail) {
                this.forgotPasswordEmailError = this.$t('validations.email');
                return;
            }

            if (!this.validateEmail(this.forgotPasswordEmail)) {
                this.forgotPasswordEmailError = this.$t('validations.v_email');
                return;
            }

            // Start submission
            this.forgotPasswordSubmitting = true;

            const data = {
                email: this.forgotPasswordEmail
            };

            // Make API call
            API.checkEmail(
                data,
                (response) => {
                    this.forgotPasswordSubmitting = false;

                    if (response.status === 200) {
                        this.forgotPasswordSuccess = true;
                        this.forgotPasswordSuccessMessage = this.$t('validations.reset_email_link_sent');
                    } else {
                        this.forgotPasswordError = true;
                        this.forgotPasswordErrorMessage = this.$t('validations.failed_email_link');
                    }
                },
                (error) => {
                    this.forgotPasswordSubmitting = false;
                    this.forgotPasswordError = true;
                    this.forgotPasswordErrorMessage = this.$t('validations.email_not_found');

                    console.error('Forgot password error:', error);
                }
            );
        },
        setActiveMenu(menu) {
            this.activeMenu = menu;
            this.activeMenu = this.activeMenu === menu ? null : menu;
        },
        backToLogin() {
            // Close forgot password modal
            this.closeForgotPasswordModal();

            // Open login modal
            this.$bvModal.show('modal-4');
        },
        handleSearchClick(city, state, country, s1date, e1date, quantity) {
            this.city = city;
            this.regionName = state;
            this.country = country;
            this.s1date = s1date || this.s1date;
            this.e1date = e1date || this.e1date;
            this.quantity = quantity || this.quantity;
            this.query = `${city}, ${state}, ${country}`;
            this.searchQuery = this.query;
            this.updateSearchPlaceholder(city, state, country);
            this.updateRecentSearches({
                city,
                state,
                country,
                s1date: this.s1date,
                e1date: this.e1date,
                quantity: this.quantity,
            });
            this.emitAllFilters();
            this.closeAllLocationModals();
            document.querySelectorAll('.tab-pane').forEach(pane => {
                pane.classList.remove('active');
            });
            this.isTabActive = false;
            if (window.innerWidth <= 768) {
                this.centerTabActive = false;  // Close panel after selecting recent search
            }
        },
        // handleSearchClick(city, county, state, s11date, e11date, quantity1) {
        //     const s1date = s11date;
        //     const e1date = e11date;
        //     const quantity = quantity1;

        //     // this.$root.$emit('load-items', city, county, state, s1date, e1date, quantity); 
        //     // this.updateSearchPlaceholder(city, county, state);
        //     this.updateSearchPlaceholder(city, county, '');
        //     this.emitAllFilters();

        //     document.querySelectorAll('.tab-pane').forEach(pane => {
        //         pane.classList.remove('active');
        //     });

        // },
        // handlePopularClick(city, county, state) {

        //     let searches = JSON.parse(localStorage.getItem("recentSearches")) || [];
        //     searches = searches.filter(s => s.city !== city || s.county !== county);
        //     searches.push({ city: city, county: county });
        //     if (searches.length > 4) {
        //         searches.shift();
        //     }
        //     localStorage.setItem("recentSearches", JSON.stringify(searches));
        //     // this.$root.$emit('load-items', city, county, state, s1date, e1date, quantity); 
        //     // this.updateSearchPlaceholder(city, county, state);
        //     this.updateSearchPlaceholder(city, county, state);
        //     this.emitAllFilters();

        //     document.querySelectorAll('.tab-pane').forEach(pane => {
        //         pane.classList.remove('active');
        //     });
        // },
        handlePopularClick(city, state, country) {
            this.city = city;
            this.regionName = state;
            this.country = country;
            this.query = `${city}, ${state}, ${country}`;
            this.searchQuery = this.query;
            this.updateSearchPlaceholder(city, state, country);
            this.updateRecentSearches({
                city,
                state,
                country,
                s1date: this.s1date,
                e1date: this.e1date,
                quantity: this.quantity,
            });
            this.emitAllFilters();
            this.closeAllLocationModals();
            document.querySelectorAll('.tab-pane').forEach(pane => {
                pane.classList.remove('active');
            });
            this.isTabActive = false;
        },
        updateRecentSearches(search) {
            // Remove duplicates
            this.recentSearches = this.recentSearches.filter(
                s => s.city !== search.city || s.state !== search.state || s.country !== search.country
            );
            // Add new search
            this.recentSearches.push({
                city: search.city,
                state: search.state || '',
                country: search.country,
                s1date: search.s1date || '',
                e1date: search.e1date || '',
                quantity: search.quantity || '',
            });
            // Limit to 5 searches
            if (this.recentSearches.length > 5) {
                this.recentSearches.shift();
            }
            // Save to localStorage
            localStorage.setItem('recentSearches', JSON.stringify(this.recentSearches));
        },
        loadRecentSearches() {
            const stored = localStorage.getItem('recentSearches');
            if (stored) {
                this.recentSearches = JSON.parse(stored);
            }
        },
        emitAllFilters() {
            const type = this.buttons[this.selectedButtonIndex].type === 'All Types' ? null : this.buttons[this.selectedButtonIndex].type;
            const payload = {
                city: this.city,
                country: this.country,
                state: this.regionName,
                startdate: this.s1date,
                enddate: this.e1date,
                guests: this.quantity,
                targetAudience: type || this.selectedTargetAudience,
                min: this.minPrice,
                max: this.maxPrice,
                kit: this.isKitchenActive ? 1 : 0,
                wifi: this.isWifiActive ? 1 : 0,
                tv: this.isTvActive ? 1 : 0,
                bed: this.bedrooms,
                bath: this.bathrooms,
                fav: this.isFavorited ? 1 : 0,
                child: this.childQuantity,
                pet: this.petQuantity,
                dic: this.selected || null,
                propertyType: this.selectedPropertyType,
                searchText: this.searchQuery,
                currency: this.currentcurrency || null,
                ratingRange: this.ratingRange || null,
            };
            this.$root.$emit('load-items-unified', payload);
        },
        // emitAllFilters() {
        //     let type = this.buttons[this.selectedButtonIndex].type;
        //     if (type == 'All Types') {
        //         type = null;
        //     }
        //     const payload = {
        //         city: this.city,
        //         country: this.country,
        //         state: this.state,
        //         startdate: this.s1date,
        //         enddate: this.e1date,
        //         guests: this.quantity,
        //         targetAudience: type || this.selectedTargetAudience,
        //         min: this.minPrice,
        //         max: this.maxPrice,
        //         kit: this.isKitchenActive ? 1 : 0,
        //         wifi: this.isWifiActive ? 1 : 0,
        //         tv: this.isTvActive ? 1 : 0,
        //         bed: this.bedrooms,
        //         bath: this.bathrooms,
        //         fav: this.isFavorited ? 1 : 0,
        //         child: this.childQuantity,
        //         pet: this.petQuantity,
        //         dic: this.selected || null,
        //         propertyType: this.selectedPropertyType,
        //         // targetAudience: this.selectedTargetAudience,
        //         searchText: this.searchQuery,
        //         currency: this.currentcurrency || null,
        //         ratingRange: this.ratingRange || null
        //     };
        //     this.$root.$emit('load-items-unified', payload);
        // },
        resetFilters() {
            this.selectedPropertyType = '';
            this.selectedTargetAudience = '';
            this.selected = '';
            this.bedrooms = "";
            this.bathrooms = "";
            this.isKitchenActive = false;
            this.isWifiActive = false;
            this.isTvActive = false;
            this.ratingRange = '';
            this.value_2 = [0, this.maxCount];
            this.minPrice = 0;
            this.maxPrice = this.maxCount;
            localStorage.removeItem('bed');
            localStorage.removeItem('bath');
            localStorage.removeItem('minPrice');
            localStorage.removeItem('maxPrice');

            this.query = '';
            this.searchQuery = null;
            this.emitAllFilters();
            // this.$root.$emit('load-items', '', '', '', '', '', 1);

            this.closeModal();
        },
        observeDatePickerPopup() {
            const observer = new MutationObserver(() => {
                const drpButtons = document.querySelector('.drp-buttons');
                if (!drpButtons) return;

                // Wait until cancel button is definitely present
                const cancelBtn = drpButtons.querySelector('.cancelBtn');
                if (!cancelBtn) return;

                // Bind only once
                if (!cancelBtn.dataset.resetBound) {
                    cancelBtn.addEventListener('click', () => {
                        this.resetDateRange();
                        // Close popup safely
                        const picker = this.$refs.datePickerRef?.picker;
                        if (picker?.hide) picker.hide();
                    });

                    cancelBtn.dataset.resetBound = "true";
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        },

        resetDateRange() {
            const today = new Date();
            this.dateRange = { startDate: today, endDate: today };
            this.sdate = this.formatDate(today);
            this.edate = this.formatDate(today);
            this.showAddDatesText = true;
            this.$EventBus.$emit('clear-dates');
            if (window.innerWidth <= 768) {
                this.centerTabActive = false;
            }
        },

        formatDate(date) {
            const dateObj = date instanceof Date ? date : new Date(date);
            if (isNaN(dateObj.getTime())) {
                console.error('Invalid date passed to formatDate:', date);
                return '';
            }
            const vueLocale = this.$i18n.locale || 'en';
            const localeMap = {
                'en': 'en-US',        // English US: "Nov 12" (month-day)
                'es': 'es-ES',        // Spanish: "12 nov" (day-month)
                'de': 'de-DE',        // Deutsch (German): "12. Nov" (day-month with dot)
                'fr': 'fr-FR',        // French: "12 nov." (day-month, lowercase)
                'nl': 'nl-NL',        // Nederlands (Dutch): "12 nov" (day-month)
                'cn': 'zh-CN',        // Chinese (Simplified): "11月12日" (numeric month + 日)
                'es-ar': 'es-AR',     // Spanish Argentina: "12 nov" (day-month, regional variants)
                'es-mx': 'es-MX',     // Spanish Mexico: "12 nov" (day-month, regional variants)
                'ca': 'ca-ES',        // Català (Catalan): "12 nov" (day-month)
                'it': 'it-IT'         // Italiano (Italian): "12 nov" (day-month)
            };
            let intlLocale = localeMap[vueLocale] || vueLocale;
            const options = {
                month: 'short',
                day: 'numeric'
            };
            return new Intl.DateTimeFormat(intlLocale, options).format(dateObj);
        },
        closeModal() {
            this.$refs.modal.hide();  // This will hide the modal
        },

        filterData() {
            // if (this.value_2) {
            //     this.$root.$emit('load-items2', this.value_2[0], this.value_2[1]);
            // }
            this.$refs.modal.hide();
        },
        setActiveButton(button) {
            this.activeButton = button;
        },
        updatePriceRange(value) {
            this.setPriceRange(value);
        },
        formatter(value) {
            return `${value} ${this.selectedCurrencyIcon}`;
        },
        setActive(place) {
            this.selectedPlace = place;
        },
        exploreNearby() {
            fetch('https://api.ipify.org?format=json')
                .then(response => {
                    if (!response.ok) throw new Error(`Error fetching IP: ${response.status}`);
                    return response.json();
                })
                .then(data => {
                    fetch('https://ipwho.is/' + data.ip)
                        .then(response => response.json())
                        .then(locationData => {
                            localStorage.setItem('region', locationData.country);
                            this.city = locationData.city;
                            this.regionName = locationData.region;
                            this.country = locationData.country;
                            this.query = `${this.city}, ${this.regionName}, ${this.country}`;
                            this.searchQuery = this.query;
                            this.updateSearchPlaceholder(this.city, this.regionName, this.country);
                            this.updateRecentSearches({
                                city: this.city,
                                state: this.regionName,
                                country: this.country,
                                s1date: this.s1date,
                                e1date: this.e1date,
                                quantity: this.quantity,
                            });
                            this.emitAllFilters();
                            document.querySelectorAll('.tab-pane').forEach(pane => {
                                pane.classList.remove('active');
                            });
                            this.isTabActive = false;
                            if (window.innerWidth <= 768) {
                                this.centerTabActive = false;
                            }
                        })
                        .catch(error => {
                            console.error('Error fetching location details:', error);
                            this.$swal({
                                icon: 'error',
                                title: this.$t('sweetalert.Oops'),
                                text: this.$t('property_detail.geolocation_error'),
                            });
                        });
                })
                .catch(error => {
                    console.error('Error fetching IP address:', error);
                    this.$swal({
                        icon: 'error',
                        title: this.$t('sweetalert.Oops'),
                        text: this.$t('property_detail.geolocation_error'),
                    });
                });
        },
        // exploreNearby() {
        //     fetch('https://api.ipify.org?format=json')
        //         .then(response => {
        //             if (!response.ok) {
        //                 throw new Error(`Error fetching IP: ${response.status} ${response.statusText}`);
        //             }
        //             return response.json();
        //         })
        //         .then(data => {
        //             fetch('https://ipwho.is/' + data.ip)
        //                 .then(response => response.json())
        //                 .then(locationData => {
        //                     localStorage.setItem('region', locationData.country);
        //                     this.city = locationData.city;
        //                     this.country = locationData.country;
        //                     this.regionName = locationData.regionName;
        //                     // this.$root.$emit('load-items', this.city);
        //                     this.emitAllFilters();
        //                     this.updateSearchPlaceholder(this.city, this.country, this.regionName);
        //                 })
        //                 .catch(error => {
        //                     console.error('Error fetching location details:', error);
        //                 });
        //         })
        //         .catch(error => {
        //             console.error('Error fetching IP address:', error);
        //         });
        //     document.querySelectorAll('.tab-pane').forEach(pane => {
        //         pane.classList.remove('active');
        //     });
        // },
        openCamera() {
            navigator.mediaDevices.getUserMedia({ video: true })
                .then(stream => {
                    this.cameraStream = stream;
                    this.isCameraOpen = true;
                    setTimeout(() => {
                        if (this.$refs.cameraVideo) {
                            this.$refs.cameraVideo.srcObject = stream;
                        } else {
                            console.error("Video element not found in $refs.");
                        }
                    }, 100);
                })
                .catch(error => {
                    console.error("Camera access denied:", error);
                    this.$swal("Error", "Camera access is required to take a photo.", "error");
                });
        },
        captureImage() {
            const video = this.$refs.cameraVideo;
            if (video) {
                const canvas = document.createElement('canvas');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                const context = canvas.getContext('2d');
                context.drawImage(video, 0, 0, canvas.width, canvas.height);

                // Convert the canvas image to a PNG Data URL and preview it
                this.profilePhotoPreview = canvas.toDataURL('image/png');
                this.profilePhoto = this.dataURItoFile(this.profilePhotoPreview, 'profile_image.png');

                // Close camera stream after capturing
                this.closeCamera();
            }
        },
        closeCamera() {
            if (this.cameraStream) {
                this.cameraStream.getTracks().forEach(track => track.stop());
                this.cameraStream = null;
            }
            this.isCameraOpen = false;
        },
        dataURItoFile(dataURI, filename) {
            const byteString = atob(dataURI.split(',')[1]);
            const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new File([ab], filename, { type: mimeString });
        },
        onProfileChange(event) {
            // Preview uploaded photo
            this.profilePhoto = event.target.files[0];
            if (this.profilePhoto) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.profilePhotoPreview = e.target.result;
                };
                reader.readAsDataURL(this.profilePhoto);
            }
        },

        removeImage() {
            this.profilePhoto = null;
            this.profilePhotoPreview = null;
        },
        verifyEmail() {
            this.$bvModal.hide('modal-4');
            this.$bvModal.show('modal-6');
        },
        createaccount() {
            this.$bvModal.hide('modal-4');
            this.$bvModal.show('modal-5');
        },
        createaccount1() {
            this.$bvModal.hide('modal-6');
            this.$bvModal.show('modal-5');
        },
        getFilterPrices() {
            let currecny = localStorage.getItem('currency');
            API.getFilterPrices(currecny,
                data => {
                    this.filterPrices = data.data.filterPrices
                }, err => (
                    console.log(err)
                ))
        },
        getUserProperties() {
            let Authorization = localStorage.getItem('isLoggedin');
            if (Authorization) {
                API.getProperties(this.serverParams,
                    data => {
                        if (data.totalRecords > 0) {
                            this.showManageProperties = true;
                        }
                    }, err => {
                        console.log(err)
                    })
            }
        },
        loadButtonStates() {
            this.isKitchenActive = localStorage.getItem('kitchen') === '1';
            this.isWifiActive = localStorage.getItem('wifi') === '1';
            this.isTvActive = localStorage.getItem('tv') === '1';
            this.isPoolActive = localStorage.getItem('With_pool') === '1';
        },
        toggleKitchen() {
            // let ket = localStorage.getItem('kitchen');
            // if (ket) {
            //     localStorage.removeItem('kitchen');
            // } else {
            //     localStorage.setItem('kitchen', 1);
            //     // this.$root.$emit('load-items11', 1, '', '')
            // }
            this.isKitchenActive = !this.isKitchenActive;
            this.emitAllFilters();
        },
        toggleWifi() {
            // let wifi = localStorage.getItem('wifi');
            // if (wifi) {
            //     localStorage.removeItem('wifi');
            // } else {
            //     localStorage.setItem('wifi', 1);
            //     // this.$root.$emit('load-items11', '', 1, '')

            // }
            this.isWifiActive = !this.isWifiActive;
            this.emitAllFilters();
        },
        toggleTv() {
            // let tv = localStorage.getItem('tv');
            // if (tv) {
            //     localStorage.removeItem('tv');
            // } else {
            //     localStorage.setItem('tv', 1);
            //     // this.$root.$emit('load-items11', '', '', 1)
            // }
            this.isTvActive = !this.isTvActive;
            this.emitAllFilters();
        },
        togglePool() {
            // let With_pool = localStorage.getItem('With_pool');
            // if (With_pool) {
            //     localStorage.removeItem('With_pool');
            // } else {
            //     localStorage.setItem('With_pool', 1);
            //     // this.$root.$emit('load-items11', '', '', 1)

            // }
            this.isPoolActive = !this.isPoolActive;
            this.emitAllFilters();
        },
        incrementbed() {
            // this.bedrooms++;
            // localStorage.setItem('bed', this.bedrooms);
            // const bath = localStorage.getItem('bath');
            this.emitAllFilters();
            // this.$root.$emit('load-items8', this.s1date, this.e1date, this.quantity, this.bedrooms, bath, this.minPrice, this.maxPrice, this.childQuantity, this.petQuantity,this.selectedPropertyType);
            // this.$root.$emit('load-items8', this.bedrooms, bath, minPrice, maxPrice);
        },
        decrementbed() {
            if (this.bedrooms < 1) {
                alert("Negative quantity not allowed");
            } else {
                this.bedrooms--;
                localStorage.setItem('bed', this.bedrooms);
                const bath = localStorage.getItem('bath')
                if (bath) {
                    this.$root.$emit('load-items8', this.s1date, this.e1date, this.quantity, this.bedrooms, bath, this.minPrice, this.maxPrice, this.childQuantity, this.petQuantity, this.selectedPropertyType);
                    // this.$root.$emit('load-items8', this.bedrooms, bath)
                } else {
                    this.$root.$emit('load-items8', this.s1date, this.e1date, this.quantity, this.bedrooms, bath, this.minPrice, this.maxPrice, this.childQuantity, this.petQuantity, this.selectedPropertyType);
                    // this.$root.$emit('load-items8', this.bedrooms, '')
                }
            }
        },
        incrementbath() {
            // this.bathrooms++;
            // localStorage.setItem('bath', this.bathrooms);
            // const bed = localStorage.getItem('bed');
            this.emitAllFilters();
            //    this.$root.$emit('load-items8', this.s1date, this.e1date, this.quantity, this.bedrooms, bed, this.minPrice, this.maxPrice, this.childQuantity, this.petQuantity,this.selectedPropertyType);
            // this.$root.$emit('load-items8', this.bedrooms, bed, minPrice, maxPrice);
        },
        decrementbath() {
            if (this.bathrooms < 1) {
                alert("Negative quantity not allowed");
            } else {
                this.bathrooms--;
                localStorage.setItem('bath', this.bathrooms);
                const bed = localStorage.getItem('bed')
                if (bed) {
                    this.$root.$emit('load-items8', this.s1date, this.e1date, this.quantity, this.bedrooms, bed, this.minPrice, this.maxPrice, this.childQuantity, this.petQuantity, this.selectedPropertyType);
                    // this.$root.$emit('load-items8', bed, this.bathrooms)
                } else {
                    this.$root.$emit('load-items8', this.s1date, this.e1date, this.quantity, this.bedrooms, bed, this.minPrice, this.maxPrice, this.childQuantity, this.petQuantity, this.selectedPropertyType);
                    // this.$root.$emit('load-items8', '', this.bathrooms)
                }
            }
        },
        disountProperties() {
            // alert('heres');
            if (this.bathrooms < 1) {
                alert("Error Searching.");
            } else {
                this.bathrooms--;
                localStorage.setItem('bath', this.bathrooms);
                const bed = localStorage.getItem('bed')
                if (bed) {
                    this.$root.$emit('load-items8', this.s1date, this.e1date, this.quantity, this.bedrooms, bed, this.minPrice, this.maxPrice, this.childQuantity, this.petQuantity, this.selectedPropertyType)
                } else {
                    this.$root.$emit('load-items8', '', this.bathrooms)
                }
            }
        },
        async changecurrency(cur, isLoad = true) {
            await this.covertcurency(this.maxCount, this.currentcurrency, cur);
            this.currentcurrency = cur;
            this.$refs.myModal.hide();
            localStorage.setItem('currency', cur)
            API.getCurrency(cur,
                data => {
                    // this.selectedCurrencyIcon = 'https://staging.cheapcomforts.com/public/images/'+data.data.currency.images;
                    this.selectedCurrencyIcon = data.data.currency.currency_code;
                },
                err => {
                    console.log(err);
                }
            )
            if (isLoad) {
                this.getFilterPrices()
                this.emitAllFilters();
            }
            this.$root.$emit('currency-changed', cur);
        },
        async changeCurrencyMount(cur) {
            await this.covertcurency(this.maxCount, this.currentcurrency, cur);
            this.currentcurrency = cur;
            this.$refs.myModal.hide();
            localStorage.setItem('currency', cur)
            API.getCurrency(cur,
                data => {
                    // this.selectedCurrencyIcon = 'https://staging.cheapcomforts.com/public/images/'+data.data.currency.images;
                    this.selectedCurrencyIcon = data.data.currency.currency_code;
                },
                err => {
                    console.log(err);
                }
            )
        },
        onVerify(recaptchaToken) {
            this.recaptchaToken = recaptchaToken;
        },
        onVerify1(recaptchaToken) {
            this.recaptchaToken1 = recaptchaToken;
        },
        resetRecaptcha() {
            this.recaptchaToken = null;
            if (this.$refs.recaptchaRef) {
                this.$refs.recaptchaRef.reset();
            } else {
                console.warn('recaptchaRef is not available');
            }
        },
        fetch2FASetup() {
            API.generate2FASetup({
                email: this.tempEmail,
                password: this.password   // you already store it in login
            },
                res => {
                    this.setupQr = res.qr_code;
                    this.setupSecret = res.secret;
                },
                err => {
                    this.$swal(
                        this.$t('alerts.error'),
                        err.data?.message || this.$t('twofa.qr_load_failed'),
                        'error'
                    );
                });
        },
        confirmEnable2FA() {
            if (this.is2FAEnableDisabled) return;

            this.verifying2FASetup = true;

            API.enable2FA({
                email: this.tempEmail,
                password: this.password,
                code: this.twoFactorCodeInput
            }, res => {
                this.verifying2FASetup = false;

                this.$swal(
                    this.$t('alerts.success'),
                    this.$t('twofa.enabled_success'),
                    'success'
                );
                this.show2faSetupModal = false;
                this.reset2FASetupCode();
                setTimeout(() => {
                    this.show2faModal = true;
                }, 300);
            },
                err => {
                    this.verifying2FASetup = false;
                    this.$swal(
                        this.$t('alerts.error'),
                        err.data?.message || this.$t('twofa.invalid_code'),
                        'error'
                    ); this.reset2FASetupCode();
                });
        },
        login() {
            if (this.email == '') {
                this.showError = true;
                this.error = this.$t('validations.email');
                this.resetRecaptcha();
                return;
            } else if (this.password == '') {
                this.showError = true;
                this.error = this.$t('validations.password');
                this.resetRecaptcha();
                return;
            } else if (this.password.length < 6) {
                this.showError = true;
                this.error = this.$t('validations.min_password');
                this.resetRecaptcha();
                return;
            } else {
                var re = /\S+@\S+\.\S+/;
                if (re.test(this.email)) {
                    this.showError = false;
                    if (!this.recaptchaToken) {
                        this.showError = true;
                        this.error = this.$t('validations.complete_recaptcha');
                        this.resetRecaptcha();
                        return;
                    }
                } else {
                    this.showError = true;
                    this.error = this.$t('validations.v_email');
                    this.resetRecaptcha();
                    return;
                }
            }

            if (!this.recaptchaToken) {
                this.showError = true;
                this.error = this.$t('validations.complete_recaptcha');
                return;
            }

            let email = this.email
            let password = this.password
            let remember_be = this.remember_be
            let recaptchatoke = this.recaptchaToken
            let data = {
                email: email,
                password: password,
                remember_be: remember_be,
                recaptcha_token: recaptchatoke
            }
            this.disabled = true;
            API.loginAsGuest(data,
                data => {
                    if (data.two_factor_setup_required) {
                        if (this.$refs.loginModalRef) this.$refs.loginModalRef.hide();
                        this.tempEmail = this.email;

                        setTimeout(() => {
                            this.show2faSetupModal = true;   // <-- watcher triggers fetch2FASetup()
                        }, 300);

                        return;
                    }

                    if (data.two_factor_required) {
                        // hide login, open 2FA verify modal
                        this.tempEmail = this.email;
                        if (this.$refs.loginModalRef) this.$refs.loginModalRef.hide();
                        setTimeout(() => { this.show2faModal = true; }, 300);
                        return;
                    }

                    if (typeof data.token !== "undefined") {
                        localStorage.setItem('isLoggedin', data.token)
                        localStorage.setItem('client_settings', JSON.stringify(data.client_settings))
                        localStorage.setItem('user', JSON.stringify(data.user))
                        localStorage.setItem('userPermissions', JSON.stringify(data.permission))
                        localStorage.setItem('password', this.password)
                        if (this.remember_be == 'true') {
                            localStorage.setItem('email', this.email)
                            localStorage.setItem('password', this.password)
                        }
                        this.$refs.loginModalRef.hide()
                        const originalUrl = localStorage.getItem('originalUrl');
                        const user = data.user;
                        const roles = user?.roles ?? [];
                        const isSuperAdmin = roles.length > 0 && roles[0].name === 'Admin';

                        if (isSuperAdmin) {
                            this.$router.push({ name: 'dashboard' });
                        } else if (originalUrl) {
                            location.reload();
                            this.$router.push(originalUrl);
                            localStorage.removeItem('originalUrl');
                        } else {
                            location.reload();
                            this.$router.push({ name: 'home' });
                        }
                    } else {
                        this.$swal({
                            icon: 'error',
                            type: 'error',
                            title: this.$t('sweetalert.Oops'),
                            text: data.message,
                        })
                        this.resetRecaptcha();
                        if (data.message == 'Please verify your email before logging in.') {
                            this.emailnotverified = true;

                        }
                    }
                },
                err => {
                    this.$swal({
                        icon: 'error',
                        type: 'error',
                        title: this.$t('sweetalert.Oops'),
                        text: err.data.message,
                    })
                    this.resetRecaptcha();
                }

            )
        },
        verify2FA() {
            const finalCode = this.otp.join('');
            if (finalCode.length !== 6) {
                this.$swal(
                    this.$t('alerts.error'),
                    this.$t('twofa.enter_6_digit'),
                    'error'
                );
                this.resetOtpInputs();
                return;
            }

            API.verifyGoogle2FA({ email: this.tempEmail, code: finalCode },
                res => {
                    if (res.token) {
                        localStorage.setItem('isLoggedin', res.token);
                        localStorage.setItem('client_settings', JSON.stringify(res.client_settings || {}));
                        localStorage.setItem('user', JSON.stringify(res.user));
                        localStorage.setItem('userPermissions', JSON.stringify(res.permission || []));
                        this.show2faModal = false;
                        this.$router.push({ name: 'dashboard' });
                    } else {
                        // if your _token returns differently, adapt accordingly
                        this.$swal(
                            this.$t('alerts.success'),
                            this.$t('twofa.login_success'),
                            'success'
                        );
                    }
                },
                err => {
                    this.$swal(
                        this.$t('alerts.error'),
                        err.data?.message || this.$t('twofa.invalid_code'),
                        'error'
                    ); this.resetOtpInputs();
                }
            );
        },
        resetOtpInputs() {
            this.otp = ['', '', '', '', '', ''];

            this.$nextTick(() => {
                const first = this.$refs.otp0;
                if (first && first[0]) {
                    first[0].focus();
                }
            });
        },
        reset2FASetupCode() {
            this.twoFactorCodeInput = '';
            this.twoFactorCodeError = '';

            this.$nextTick(() => {
                const input = this.$el.querySelector('input[placeholder="Enter 6-digit code"]');
                if (input) input.focus();
            });
        },

        moveToNext(e, index) {
            const val = e.target.value;
            if (val.length >= 1 && index < 5) {
                const nextRef = this.$refs['otp' + (index + 1)];
                if (nextRef && nextRef[0]) nextRef[0].focus();
            }
        },
        moveToPrev(e, index) {
            if (!this.otp[index] && index > 0) {
                const prevRef = this.$refs['otp' + (index - 1)];
                if (prevRef && prevRef[0]) prevRef[0].focus();
            }
        },
        handleInput(e, index) {
            let val = e.target.value;
            val = val.replace(/[^0-9]/g, '');
            this.$set(this.otp, index, val);

            if (val && index < 5) {
                const next = this.$refs['otp' + (index + 1)];
                if (next && next[0]) next[0].focus();
            }
        },

        handleBackspace(e, index) {
            if (this.otp[index]) {
                this.$set(this.otp, index, '');
            } else if (index > 0) {
                const prev = this.$refs['otp' + (index - 1)];
                if (prev && prev[0]) {
                    prev[0].focus();
                    this.$set(this.otp, index - 1, '');
                }
            }
        },
        handlePaste(e) {
            e.preventDefault();
            const paste = e.clipboardData.getData('text').replace(/\D/g, '');
            if (paste.length !== 6) return;
            paste.split('').forEach((num, i) => {
                this.$set(this.otp, i, num);
            });
            const last = this.$refs['otp5'];
            if (last && last[0]) last[0].focus();
        },
        AuthProvider(provider) {
            if (provider === 'google') {
                // 1. Manually build the Google URL
                const clientId = "788888898566-k87c2o8222f3c6ig66vqtsvsild3n6pl.apps.googleusercontent.com";
                const redirectUri = "https://staging.cheapcomforts.com/login/google/callback";
                // const redirectUri = "http://localhost:8080/login/google/callback";
                // This replaces this.$auth.authenticate
                const scope = "email profile openid";
                const url = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}`;
                // 2. Open the popup
                const width = 500;
                const height = 600;
                const left = (window.screen.width / 2) - (width / 2);
                const top = (window.screen.height / 2) - (height / 2);

                window.open(url, "google_login", `width=${width},height=${height},top=${top},left=${left}`);
            }
            else if (provider === 'facebook') {
                // Your Facebook App Credentials
                const clientId = "1223713709675810";
                // const clientId = "1532935714336326";
                const redirectUri = "https://staging.cheapcomforts.com/auth/facebook/callback";
                // const redirectUri = "http://localhost:8080/auth/facebook/callback";
                // Facebook Scope
                const scope = "public_profile,email";

                // Facebook OAuth URL
                const url = `https://www.facebook.com/v19.0/dialog/oauth?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=${encodeURIComponent(scope)}`;

                // Popup window
                const width = 500;
                const height = 600;
                const left = (window.screen.width / 2) - (width / 2);
                const top = (window.screen.height / 2) - (height / 2);

                window.open(url, "facebook_login", `width=${width},height=${height},top=${top},left=${left}`);
            }
        },

        handleMessage(event) {
            if (event.origin !== window.location.origin) {
                console.warn("Ignored message from different origin:", event.origin);
                return;
            }
            const providerMap = {
                GOOGLE_CODE_SUCCESS: 'google',
                FACEBOOK_CODE_SUCCESS: 'facebook'
            };
            const provider = providerMap[event.data.type];
            if (provider) {
                this.finalizeLogin(provider, event.data.code);
            }
        },

        finalizeLogin(provider, code) {
            const data = {
                provider: provider,
                accessToken: code,
            };
            API.socialLogin(data,
                (response) => {
                    if (response.token) {
                        localStorage.setItem('isLoggedin', response.token);
                        localStorage.setItem('user', JSON.stringify(response.user));
                        localStorage.setItem('userPermissions', JSON.stringify(response.permissions));
                        localStorage.setItem('isAuthenticatedToAccessWebsite', 'true');

                        if (this.$refs.loginModalRef) {
                            this.$refs.loginModalRef.hide();
                        }

                        const originalUrl = localStorage.getItem('originalUrl');
                        if (originalUrl) {
                            localStorage.removeItem('originalUrl');
                            window.location.href = originalUrl;
                        } else {
                            window.location.href = '/';
                        }
                    } else {
                        this.$swal({
                            icon: 'error',
                            title: this.$t('sweetalert.Oops'),
                            text: response.message || 'Login failed',
                        });
                    }
                },
                (err) => {
                    console.error('API error:', err);
                    this.$swal({
                        icon: 'error',
                        title: this.$t('sweetalert.Oops'),
                        text: err?.data?.message || 'Something went wrong during login.',
                    });
                }
            );
        },
        fetchCurrency() {
            return new Promise((resolve, reject) => {
                axios.get('https://ipapi.co/currency/')
                    .then(response => {
                        localStorage.setItem('currency', response.data);
                        resolve();
                    })
                    .catch(error => {
                        this.currentcurrency = 'USD';
                        localStorage.setItem('currency', 'USD');
                        console.error('Error fetching currency:', error);
                        resolve();
                    });
            });
        },
        async covertcurency(price, currency, ipCurrency) {
            try {
                const response = await fetch('https://api.exchangerate-api.com/v4/latest/' + currency);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();

                if (!data.rates || !data.rates[ipCurrency]) {
                    throw new Error('Invalid exchange rate data');
                }

                const iprate = data.rates[ipCurrency];
                let convertedPrice = iprate * price;

                // Ensure convertedPrice is a valid number
                if (isNaN(convertedPrice) || !isFinite(convertedPrice)) {
                    throw new Error('Invalid conversion result');
                }

                // Round to nearest integer to avoid floating point issues
                this.maxCount = Math.round(convertedPrice);
                this.maxPrice = this.maxCount
                // Ensure value_2 is also updated with valid values
                this.value_2 = [0, this.maxCount];
            } catch (error) {
                console.error('Error in currency conversion:', error);
                // Fallback to default values if conversion fails
                this.maxCount = 1600;
                this.value_2 = [0, 1600];
            }
        },

        async fetchcountryMount(c_code) {
            try {
                await new Promise((resolve, reject) => {
                    API.getalllanguages(
                        c_code,
                        async (languageResponse) => {
                            this.languages = languageResponse.data.data;

                            const lang = localStorage.getItem('language');
                            const flag = localStorage.getItem('flag');
                            const currency = localStorage.getItem('currency') || this.currentcurrency;

                            if (lang) {
                                this.selectedLanguage = lang;
                                await this.changeLanguage(lang, flag, currency, false);
                            } else {
                                const langCode = languageResponse.data.languagecode;
                                const flagUrl = 'https://staging.cheapcomforts.com/public/images/' + languageResponse.data.flag;
                                await this.changeLanguage(langCode, flagUrl, currency, false);
                                this.selectedLanguage = langCode;
                            }

                            resolve();
                        },
                        (error) => {
                            console.error('Error fetching languages:', error);
                            reject(error);
                        }
                    );
                });

            } catch (error) {
                this.currency = 'USD';
                console.error('Error in fetchcountryMount:', error);
            }
        },

        async loadPlacesService() {
            const loader = new Loader({
                apiKey: process.env.VUE_APP_GOOLE_PLACES_API_KEY,
                version: 'weekly',
                libraries: ['places']
            });

            try {
                await loader.load();
                this.placesService = new window.google.maps.places.AutocompleteService();
            } catch (error) {
                console.error('Error loading Google Maps API:', error);
            }
        },
        onInput() {
            this.searchQuery = this.query;
            if (this.query.length > 0) {
                document.getElementById('__BVID__15').classList.remove("active");
            }
            if (this.query.length < 3) {
                this.suggestions = [];
                return;
            }
            this.debouncedFetchSuggestions();
        },
        fetchSuggestions() {
            if (!this.placesService || !this.query) {
                this.suggestions = [];
                return;
            }
            this.placesService.getPlacePredictions(
                { input: this.query, types: ['geocode'] },
                (predictions, status) => {
                    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                        this.suggestions = predictions || [];
                    } else {
                        console.error('Error fetching place predictions:', status);
                        this.suggestions = [];
                    }
                }
            );
        },

        async selectSuggestion(suggestion, event) {
            if (!suggestion || !suggestion.description) return;

            const placeService = new window.google.maps.places.PlacesService(document.createElement('div'));
            placeService.getDetails({ placeId: suggestion.place_id }, (place, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    let city = '';
                    let state = '';
                    let country = '';
                    place.address_components.forEach(component => {
                        if (component.types.includes('locality')) city = component.long_name;
                        if (component.types.includes('administrative_area_level_1')) state = component.long_name;
                        if (component.types.includes('country')) country = component.long_name;
                    });

                    this.city = city || suggestion.description.split(',')[0].trim();
                    this.regionName = state || '';
                    this.country = country || suggestion.description.split(',').pop().trim();
                    this.query = suggestion.description;
                    this.searchQuery = suggestion.description;
                    this.suggestions = [];

                    // Update recent searches
                    this.updateRecentSearches({
                        city: this.city,
                        state: this.regionName,
                        country: this.country,
                        s1date: this.s1date,
                        e1date: this.e1date,
                        quantity: this.quantity,
                    });

                    // Update search placeholder
                    this.updateSearchPlaceholder(this.city, this.regionName, this.country);

                    // Emit search
                    this.emitAllFilters();
                    this.closeAllLocationModals();
                    if (window.innerWidth <= 768) {
                        this.centerTabActive = false;
                    }
                } else {
                    console.error('Error fetching place details:', status);
                }
            });
            document.querySelectorAll('.tab-pane').forEach(pane => {
                pane.classList.remove('active');
            });
            this.isTabActive = false;
        },

        handleKeyUp(event) {
            if (event.key === 'Enter' && this.query) {
                this.callApiOnEnter();
            }
        },
        callApiOnEnter() {
            if (!this.query) return;
            if (this.suggestions.length > 0) {
                this.selectSuggestion(this.suggestions[0], { target: null });
            } else {
                const inputValue = this.query.toLowerCase().trim();
                const words = inputValue.split(/\s*,\s*/);
                let city = '';
                let state = '';
                let country = '';
                switch (words.length) {
                    case 1:
                        country = words[0];
                        break;
                    case 2:
                        city = words[0];
                        country = words[1];
                        break;
                    case 3:
                        city = words[0];
                        state = words[1];
                        country = words[2];
                        break;
                    default:
                        city = words[0];
                        state = words[words.length - 2] || '';
                        country = words[words.length - 1] || '';
                }

                this.city = city;
                this.regionName = state;
                this.country = country;
                this.searchQuery = this.query;
                this.updateSearchPlaceholder(city, state, country);
                this.updateRecentSearches({
                    city,
                    state,
                    country,
                    s1date: this.s1date,
                    e1date: this.e1date,
                    quantity: this.quantity,
                });
                this.emitAllFilters();
                this.closeAllLocationModals();
                // Close tab
                document.querySelectorAll('.tab-pane').forEach(pane => {
                    pane.classList.remove('active');
                });
                this.isTabActive = false;
                if (window.innerWidth <= 768) {
                    this.centerTabActive = false;
                }
            }
        },
        bookings() {
            let Authorization = localStorage.getItem('isLoggedin');
            if (Authorization) {
                this.$router.push({ name: 'my_bookings' });
            } else {
                this.$bvModal.show('modal-4');
            }

        },
        messages() {
            let Authorization = localStorage.getItem('isLoggedin');
            if (this.$route.name === 'chat') {
                return;
            }
            if (Authorization) {
                this.$router.push({ name: 'chat' });
            } else {
                this.$bvModal.show('modal-4');
            }
        },
        incomeStatistics() {
            let Authorization = localStorage.getItem('isLoggedin');
            if (Authorization) {
                this.$router.push({ name: 'income_statistics' });
            } else {
                this.$bvModal.show('modal-4');
            }
        },
        manageProperties() {
            let Authorization = localStorage.getItem('isLoggedin');
            if (Authorization) {
                this.$router.push({ name: 'manage_properties' });
            } else {
                this.$bvModal.show('modal-4');
            }
        },
        goToDashboard() {
            const Authorization = localStorage.getItem('isLoggedin');
            if (Authorization) {
                const user = JSON.parse(localStorage.getItem('user'));
                if (user && user.permissions && user.permissions.length > 0) {
                    const permission = user.permissions[0].name;
                    if (permission === 'property_owner') {
                        this.$router.push({ path: '/dashboard/' });
                    } else if (permission === 'super_admin') {
                        this.$router.push({ path: '/Admin/' });
                    } else {
                        this.$router.push({ path: '/add_property' });
                    }
                } else {
                    this.$router.push({ path: '/add_property' });
                }
            } else {
                this.$router.push({ name: 'guest_login' });
            }
        },
        toggleFavorite() {
            let Authorization = localStorage.getItem('isLoggedin');
            if (Authorization) {
                this.isFavorited = !this.isFavorited;
                if (this.isFavorited) {
                    this.$root.$emit('load-items3', this.loginUser.id)
                } else {
                    this.$root.$emit('load-items3', '')
                }
            } else {
                this.$bvModal.show('modal-4');
            }
        },
        handleTabClick(event) {
            if (event && event.target && event.target.tagName === 'INPUT') {
                if (this.query.length > 0) return;
            }
            this.isTabActive = !this.isTabActive;
            this.isFirstTime = false;

            const tabElement = document.getElementById('__BVID__15');
            const buttonElement = document.getElementById('__BVID__15___BV_tab_button__');

            if (this.isTabActive) {
                tabElement?.classList.add('active');
                buttonElement?.classList.add('active');
                // Focus the input when opening
                this.$nextTick(() => {
                    const input = document.getElementById('type-search');
                    input?.focus();
                });
            } else {
                tabElement?.classList.remove('active');
                buttonElement?.classList.remove('active');
            }

            // Always clear suggestions when opening/closing recent modal
            if (this.isTabActive) {
                this.suggestions = [];
            }
        },
        focusButton() {
            let myButton = document.getElementById('type-search');
            if (myButton) {
                myButton.focus();
            }
        },

        focusButtonVisibleIndication() {
            let myButton = document.getElementById('type-search');
            if (myButton) {
                myButton.focus({ focusVisible: true });
            }
        },
        clearSearch() {
            this.query = '';
            this.searchQuery = '';
            this.city = '';
            this.regionName = '';
            this.country = '';
            this.suggestions = [];
            this.updateSearchPlaceholder('', '', '');
            this.emitAllFilters();
            document.querySelectorAll('.tab-pane').forEach(pane => {
                pane.classList.remove('active');
            });
            this.isTabActive = false;
            if (window.innerWidth <= 768) {
                this.centerTabActive = false;
            }
        },
        updateHeaderVisibility() {
            const hideHeaderRoutes = [
                '/chat',
                '/mission',
                '/property/detail/',
                '/faq',
                '/property/rating',
                '/about-us',
                '/contact-us',
                '/my_bookings',
                '/add_property',
                '/property_details',
                '/income_statistics',
                '/property/payment',
                '/privacypolicy',
                '/cookies-policy',
                '/termsofservice',
                '/cancellation-and-refund-policy',
                '/guest-terms-and-conditions',
                '/host-terms-and-conditions',
                '/standard-contractual-clauses',
                '/data-processing-agreement',
                '/legal-disclaimer',
                '/invoice/detail/'
            ];
            const shouldHideHeader = hideHeaderRoutes.some(route => this.$route.path.startsWith(route));
            const isHomePage = this.$route.path === '/';
            if (this.hideHeader !== shouldHideHeader) {
                this.hideHeader = shouldHideHeader;
            }
            if (this.hidehomepage !== isHomePage) {
                this.hidehomepage = isHomePage;
            }
            this.updateLoginVisibility();
        },

        updateLoginVisibility() {
            const isLoggedIn = localStorage.getItem('isLoggedin');
            this.showAfterLogin = !!isLoggedIn;
            this.showBeforeLogin = !isLoggedIn;
        },
        resetPage() {
            localStorage.removeItem('bed');
            localStorage.removeItem('bath');
            window.location.reload();
        },
        setPriceRange(range) {
            localStorage.setItem('minPrice', range[0]);
            localStorage.setItem('maxPrice', range[1]);
            this.minPrice = range[0];
            this.maxPrice = range[1];
            let bed = localStorage.getItem('bed') || this.bedrooms;
            let bath = localStorage.getItem('bath') || this.bathrooms;
            this.emitAllFilters();
        },
        setratings(range) {
            this.ratingRange = range;
            this.emitAllFilters();
        },
        Addproperty() {
            console.log('Addproperty clicked');

            let Authorization = localStorage.getItem('isLoggedin');
            if (Authorization) {
                const user = JSON.parse(localStorage.getItem('user'));
                const permission = user.permissions[0].name;

                if (permission == 'property_owner') {
                    this.$router.push({ path: '/add_property' });
                } else if (permission == 'super_admin') {
                    this.$router.push({ path: '/Admin/' });
                } else if (permission == 'guest') {
                    this.$swal({
                        title: this.$t('validations.upgrade_account'),
                        type: 'info',
                        icon: 'info',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: this.$t('sweetalert.update_now')
                    }).then((result) => {
                        if (result.value) {
                            API.Sendmail(this.loginUser.id, res => {
                                if (res.status == 200) {    
                                    localStorage.removeItem('user');
                                    localStorage.setItem('user', JSON.stringify(res.data.user))
                                    localStorage.removeItem('userPermissions');
                                    localStorage.setItem('userPermissions', JSON.stringify(res.data.permission))
                                    this.showAfterLogin = true;
                                    this.showBeforeLogin = false;
                                    this.$router.push({ path: '/add_property' });   
                                }
                            }, err => {
                                console.log(err)
                            })
                        }
                    });
                }
            } else {
                this.$bvModal.show('modal-4');
            }

        },
        getFav() {
        },
        toggleDropdown() {
            this.$refs.dropdown.show();
        },
        filterByPriceRange(minPrice, maxPrice) {
            this.$emit('filter-by-price', { minPrice, maxPrice });
        },
        resetFilter() {
            this.$emit('reset-filter');
        },
        emitSortOrder() {
            this.emitAllFilters();
        },
        emitPropertyTypeFilter() {
            let bed = localStorage.getItem('bed') || this.bedrooms;
            let bath = localStorage.getItem('bath') || this.bathrooms;
            this.emitAllFilters();
        },
        emitTargetAudienceFilter() {
            let bed = localStorage.getItem('bed') || this.bedrooms;
            let bath = localStorage.getItem('bath') || this.bathrooms;
            this.emitAllFilters();
        },
        handleSearchInput() {
            this.emitAllFilters();
        },
        filterDiscountedProperties() {
            const discountedProperties = this.discountProperties.filter(property => property.discount && property.discount > 0);
        },
        updateSearchPlaceholder(city, state, country) {
            this.city = city || '';
            this.regionName = state || '';
            this.country = country || '';
            const parts = [city, state, country].filter(Boolean);
            const lastSearchedLocation = parts.join(', ');
            this.searchPlaceholder = lastSearchedLocation;
            if (lastSearchedLocation) {
                localStorage.setItem('lastSearchedLocation', lastSearchedLocation);
            } else {
                localStorage.removeItem('lastSearchedLocation');
            }
        },
        componentDidMount() {
            const lastSearchedLocation = localStorage.getItem('lastSearchedLocation');
            if (lastSearchedLocation) {
                this.searchPlaceholder = lastSearchedLocation;
            }
        },
        closeAllLocationModals() {
            const recentTab = document.getElementById('__BVID__15');
            const recentButton = document.getElementById('__BVID__15___BV_tab_button__');
            recentTab?.classList.remove('active');
            recentButton?.classList.remove('active');
            this.isTabActive = false;
            this.suggestions = [];
            document.querySelectorAll('.tab-pane.active').forEach(pane => {
                if (pane.id === '__BVID__15') {
                    pane.classList.remove('active');
                }
            });
            const input = document.getElementById('type-search');
            input?.blur();
        },
        handleClickOutside(event) {
            if (event.target.closest('.pac-container, .pac-item, .pac-matched')) {
                return;
            }
            document.getElementById('main_bar')?.classList.remove("active");
            const tabs = [
                { id: '__BVID__15', buttonId: '__BVID__15___BV_tab_button__' },
                { id: '__BVID__92', buttonId: '__BVID__92___BV_tab_button__' },
                { id: '__BVID__17', buttonId: '__BVID__17___BV_tab_button__' },
                { id: '__BVID__19', buttonId: '__BVID__19___BV_tab_button__' },
            ];

            tabs.forEach(tab => {
                const elem = document.getElementById(tab.id);
                const button = document.getElementById(tab.buttonId);

                // Skip if elements don't exist
                if (!elem || !button) return;

                const clickedInsideTab = elem.contains(event.target);
                const clickedOnButton = button.contains(event.target);

                // Only close if click was OUTSIDE both the tab content AND the button
                if (!clickedInsideTab && !clickedOnButton) {
                    elem.classList.remove('active');
                    button.classList.remove('active');

                    // Special handling for __BVID__19 (your custom toggle logic)
                    if (tab.id === '__BVID__19') {
                        const innerTabpanel = document.querySelector('div[role="tabpanel"]#__BVID__19');
                        if (innerTabpanel) {
                            if (this.clickRemove) {
                                innerTabpanel.classList.toggle('active');
                            } else {
                                innerTabpanel.classList.remove('active');
                            }
                        }
                        if (this.clickRemove) {
                            button.classList.toggle('active');
                        } else {
                            button.classList.remove('active');
                        }
                    }
                }
            });
            this.clickRemove = false;
            this.isTabActive = false;
            this.closeAllLocationModals();
        },
        removeClass() {
            const clickEvent = new Event('click', { bubbles: true, cancelable: true });
            document.body.dispatchEvent(clickEvent);
            document.getElementById('main_bar').classList.add("active");
            document.getElementById('__BVID__15').classList.toggle("active");
            document.getElementById('__BVID__15___BV_tab_button__').classList.toggle("active");
        },
        toggle_BV_tab_button() {
            const clickEvent = new Event('click', { bubbles: true, cancelable: true });
            document.body.dispatchEvent(clickEvent);
            document.getElementById('__BVID__15___BV_tab_button__').classList.toggle("active");
        },
        removeClass1() {
            document.getElementById('main_bar').classList.add("active");
            document.getElementById('__BVID__17').classList.toggle("active");
            document.getElementById('__BVID__17___BV_tab_button__').classList.toggle("active");
        },
        removeClass2() {
            this.clickRemove = true;
            const clickEvent = new Event('click', { bubbles: true, cancelable: true });
            document.body.dispatchEvent(clickEvent);
        },
        setHeaderClass() {
            this.curroutes = this.$route.path.split('/');
            if (this.curroutes[1] === 'customer' && this.curroutes[2] === 'inventory') {
                this.headerclass = 'banner';
            } else {
                this.headerclass = 'nobanner';
            }
        },
        async changeLanguage(language, flagIcon, currency, isLoad = true) {
            Vue.prototype.$EventBus.$emit('changeLanguage', language);
            this.selectedLanguage = language;
            this.selectedFlagIcon = flagIcon;
            localStorage.setItem('language', language);
            localStorage.setItem('flag', flagIcon);
            this.isLoading = false;
            this.$emit('isLoading', this.isLoading);
            await this.changecurrency('USD', isLoad);
            this.$refs.myModal1.hide();
        },
        redirectLogin(path, type) {
            if (type === 'customer') {
                const customer_token = localStorage.getItem('access_token');
                const customer = JSON.parse(localStorage.getItem('user'));
                if ((customer_token !== null && customer_token !== "") && (customer !== null && customer !== "")) {
                    if (customer.user_role === 'customer') {
                        this.$router.push({ path: '/customer' });
                    }
                } else {
                    this.$router.push({ path: path });
                }
            }
        },
        logout() {
            const user = JSON.parse(localStorage.getItem('user'));
            this.$session.clear();
            localStorage.removeItem('userPermissions');
            localStorage.removeItem('isLoggedin');
            localStorage.removeItem('email');
            localStorage.removeItem('password');
            localStorage.removeItem('super_admin_email');
            this.showAfterLogin = false;
            this.showBeforeLogin = true;
            this.$router.push({ name: 'home' });
            // notify parent layout that user logged out so it can update classes/state
            this.$emit('user-logout');
        },
        increment() {
            let bed = localStorage.getItem('bed') || this.bedrooms;
            let bath = localStorage.getItem('bath') || this.bathrooms;
            this.quantity++;
            this.emitAllFilters();
        },
        decrement() {
            let bed = localStorage.getItem('bed') || this.bedrooms;
            let bath = localStorage.getItem('bath') || this.bathrooms;
            if (this.quantity > 0) {
                this.quantity--;
                this.emitAllFilters();
            }
        },
        childIncrement() {
            let bed = localStorage.getItem('bed') || this.bedrooms;
            let bath = localStorage.getItem('bath') || this.bathrooms;
            this.childQuantity++;
            this.$root.$emit('load-items6', '', '', '', '', '', this.quantity, '', '', '', '', '', '', '', '', '', this.childQuantity, this.petQuantity, bed, bath, '', '');
        },
        childDecrement() {
            let bed = localStorage.getItem('bed') || this.bedrooms;
            let bath = localStorage.getItem('bath') || this.bathrooms;
            if (this.childQuantity > 0) {
                this.childQuantity--;
                this.$root.$emit('load-items6', '', '', '', '', '', this.quantity, '', '', '', '', '', '', '', '', '', this.childQuantity, this.petQuantity, bed, bath, '', '');
            }
        },
        petIncrement() {
            let bed = localStorage.getItem('bed') || this.bedrooms;
            let bath = localStorage.getItem('bath') || this.bathrooms;
            this.petQuantity++;
            this.$root.$emit('load-items6', '', '', '', '', '', this.quantity, '', '', '', '', '', '', '', '', '', this.childQuantity, this.petQuantity, bed, bath, '', '');

        },
        petDecrement() {
            let bed = localStorage.getItem('bed') || this.bedrooms;
            let bath = localStorage.getItem('bath') || this.bathrooms;
            if (this.petQuantity > 0) {
                this.petQuantity--;
                this.$root.$emit('load-items6', '', '', '', '', '', this.quantity, '', '', '', '', '', '', '', '', '', this.childQuantity, this.petQuantity, bed, bath, '', '');
            }
        },
        redirectToPayment() {
            if (!this.dateRange.startDate || !this.dateRange.endDate) {
                alert('Please Select Available Dates.');
            } else {
                let startDate = moment(this.dateRange.startDate);
                let formattedstartDate = startDate.format('YYYY-MM-DD');
                let endDate = moment(this.dateRange.endDate);
                let formattedendDate = endDate.format('YYYY-MM-DD');
                let bed = localStorage.getItem('bed') || this.bedrooms;
                let bath = localStorage.getItem('bath') || this.bathrooms;
                this.$router.push({ name: 'property_payment', params: { totalPrice: this.totalPrice, startDate: formattedstartDate, endDate: formattedendDate, bed, bath } });
            }
        },
        scrollLeft() {
            this.$refs.buttonSwitcher.scrollBy({
                top: 0,
                left: -200,
                behavior: 'smooth'
            });
            this.checkScroll();
        },
        scrollRight() {
            this.$refs.buttonSwitcher.scrollBy({
                top: 0,
                left: 200,
                behavior: 'smooth'
            });
            this.checkScroll();
        },
        selectButton(index) {
            this.selectedButtonIndex = index;
            this.emitAllFilters();
        },
        checkScroll() {
            const buttonSwitcher = this.$refs.buttonSwitcher;
            const { scrollLeft, scrollWidth, clientWidth } = buttonSwitcher;
            this.showLeftArrow = scrollLeft > 0;
            this.showRightArrow = scrollLeft + clientWidth < scrollWidth;
        },
        redirect(path) {
            this.$router.push({ path: path });
        },
        verifynow() {
            let data = {
                code: this.verifycode,
                email: this.regEmail1,
            }
            API.verify2fa(
                data,
                data => {
                    if (data.error) {
                        this.regMsgTextErr2 = data.error;
                        this.notfound = true;
                    } else if (data.message) {
                        this.currStep1 = 2;
                        this.emailnotverified = false;
                        this.emailverified = true;
                        this.$bvModal.hide('modal-6');
                        this.$bvModal.show('modal-4');
                    }
                },
                err => {
                    this.regMsgTextErr2 = err.data.error;
                    this.notfound = true;
                    console.log(err)
                });
        },
        sendagain() {
            let data = {
                email: this.regEmail1,
            }
            API.send2faCode(
                data,
                data => {
                    if (data.error) {
                        this.regMsgTextErr1 = data.error;
                        this.notfound = true;
                    } else if (data.message) {
                        this.currStep1 = 2;
                        this.timeLeft = 600;
                        this.codesendagain = true;
                    }
                },
                err => {
                    console.log(err)
                });
        },
        verifybuton() {
            if (this.currStep1 == 1) {
                if (this.regEmail1 == '') {
                    this.regMsgTextErr1 = this.$t('validations.email');
                } else {
                    var re1 = /\S+@\S+\.\S+/;
                    if (re1.test(this.regEmail1)) {
                        let data = {
                            email: this.regEmail1,
                        }
                        API.send2faCode(
                            data,
                            data => {
                                if (data.error) {
                                    this.regMsgTextErr1 = data.error;
                                    this.notfound = true;
                                } else if (data.message) {
                                    this.currStep1 = 2;
                                    const interval = setInterval(() => {
                                        if (this.timeLeft > 0) {
                                            this.timeLeft -= 1;
                                        } else {
                                            clearInterval(interval);
                                        }
                                    }, 1000);
                                }
                            },
                            err => {
                                console.log(err)
                            });

                    } else {
                        this.regMsgTextErr1 = this.$t('validations.v_email');
                    }
                }
            }
        },
        formatNumber(num) {
            return num < 10 ? `0${num}` : num;
        },
        async sendverifycode() {
            this.regMsgTextErr = '';
            if (this.regFname == '') {
                this.regMsgTextErr = this.$t('validations.name');
                return;
            } else if (this.regFname.length < 3) {
                this.regMsgTextErr = this.$t('validations.min_name');
            } else if (this.regFname.length > 50) {
                this.regMsgTextErr = this.$t('validations.max_name');
            } else if (this.regEmail == '') {
                this.regMsgTextErr = this.$t('validations.email');
                return;
            } else if (!this.validatePhone()) {
                return;
            }
            const data = {
                phone: this.phoneData ? this.phoneData.formatInternational : this.regPhone,
            };
            API.checkEmailExists(
                { email: this.regEmail },
                (emailExists) => {

                    if (emailExists.success && emailExists.data.exists) {
                        this.regMsgTextErr = this.$t('validations.already_registered');
                        return;
                    }

                    if (emailExists.success && !emailExists.data.exists) {
                        API.sendverificationCode(
                            data,
                            (response) => {
                                if (response.error) {
                                    this.regMsgTextErr1 = response.error;
                                    this.notfound = true;
                                } else if (response.status === 'ok') {
                                    this.codesend = true;
                                    this.verifycodenow = false;
                                    this.codesent = true;

                                    this.otpExpired = false;
                                    this.countdown = 600;
                                    if (this.timer) clearInterval(this.timer);

                                    this.updateFormattedTimer();

                                    this.timer = setInterval(() => {
                                        if (this.countdown > 0) {
                                            this.countdown--;
                                            this.updateFormattedTimer();
                                        } else {
                                            this.otpExpired = true;
                                            clearInterval(this.timer);
                                        }
                                    }, 1000);
                                }
                            },
                            (err) => {
                                this.regMsgTextErr = this.$t('validations.failed_to_send_code');
                            }
                        );
                    }
                },
                (err) => {
                    if (err.errors && err.errors.email) {
                        this.regMsgTextErr = this.$t('validations.v_email');
                    } else {
                        this.regMsgTextErr = this.$t('validations.error_checking_email');
                    }
                }
            );
        },
        vrfynow() {
            this.regMsgTextErr = '';
            if (this.vcode === '') {
                this.regMsgTextErr = this.$t('validations.enter_verification_code');
                return;
            }
            const data = {
                phone: this.phoneData ? this.phoneData.formatInternational : this.regPhone,
                code: this.vcode,
            };

            API.verifyCode(
                data,
                (response) => {
                    if (response.status === 'approved') {
                        this.verifyphonenumber = true;
                        this.phoneverifed = true;
                        this.codesend = false;
                        this.verifycodenow = false;
                        if (this.timer) clearInterval(this.timer);
                    } else {
                        this.regMsgTextErr = this.$t('validations.verification_failed');
                    }
                },
                (err) => {
                    console.log('Verification error:', err);
                    this.regMsgTextErr = this.$t('validations.invalid_code');
                }
            );
        },
        updateFormattedTimer() {
            const minutes = Math.floor(this.countdown / 60).toString().padStart(2, '0');
            const seconds = (this.countdown % 60).toString().padStart(2, '0');
            this.formattedTimer = `${minutes}:${seconds}`;
        },
        checkEmailExists(email) {
            return new Promise((resolve, reject) => {
                let data = {
                    email: email
                }
                API.checkEmailExists(
                    data,
                    data => {
                        if (data.data.exists) {
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    },
                    err => {
                        reject(err);
                    }
                )
            });
        },
        async regSub() {
            this.regMsgTextErr = '';
            if (this.currStep == 1) {
                if (this.regFname == '') {
                    this.regMsgTextErr = this.$t('validations.name');
                } else if (this.regFname.length < 3) {
                    this.regMsgTextErr = this.$t('validations.min_name');
                } else if (this.regFname.length > 50) {
                    this.regMsgTextErr = this.$t('validations.max_name');
                } else if (this.regEmail == '') {
                    this.regMsgTextErr = this.$t('validations.email');
                } else if (!this.validatePhone()) {
                    // Phone validation is handled in validatePhone()
                } if (!this.termsAccepted) {
                    this.regMsgTextErr = this.$t('validations.must_accept_terms');
                    return;
                } else if (!this.ageConfirmed) {
                    this.regMsgTextErr = this.$t('validations.must_confirm_age');
                    return;
                } else {
                    var re1 = /\S+@\S+\.\S+/;
                    if (re1.test(this.regEmail)) {
                        try {
                            const emailExists = await this.checkEmailExists(this.regEmail);
                            if (emailExists) {
                                this.regMsgTextErr = this.$t('validations.already_registered');
                                return;
                            }
                            this.currStep = 2;
                            this.regBtnText = this.$t('register.next');
                        } catch (err) {
                            this.regMsgTextErr = this.$t('validations.error_checking_email');
                        }
                    } else {
                        this.regMsgTextErr = this.$t('validations.v_email');
                    }
                }
            } else if (this.currStep == 2) {
                this.regBtnText = this.$t('register.sign_up');
                if (this.regPassword == '') {
                    this.regMsgTextErr = this.$t('validations.password');
                } else if (this.regPassword.length < 6) {
                    this.regMsgTextErr = this.$t('validations.min_password');
                } else if (this.regCpassword == '') {
                    this.regMsgTextErr = this.$t('validations.password');
                } else if (this.regPassword != this.regCpassword) {
                    this.regMsgTextErr = this.$t('validations.match_pass');
                } else if (!this.regMsgTextErr) {
                    this.currStep = 3;
                    this.regBtnText = this.$t('register.next');
                    return;
                }
            } else if (this.currStep == 3) {
                if (!this.profilePhoto) {
                    this.regMsgTextErr = this.$t('validations.profile_photo_required');
                } else {
                    this.currStep = 4;
                }
            } else if (this.currStep == 4) {
                if (!this.recaptchaToken1) {
                    this.showError = true;
                    this.regMsgTextErr = this.$t('validations.complete_recaptcha');
                    // Reset reCAPTCHA when validation fails
                    if (this.$refs.recaptchaRef) {
                        this.$refs.recaptchaRef.reset();
                        this.regBtnText = this.$t('register.sign_up');
                    }
                    return;
                } else {
                    this.regBtnText = this.$t('register.signing_up');
                    this.register();
                }
            }
        },
        ageValidation(birthYear) {
            const dateBirth = new Date(birthYear);
            const today = new Date();
            const diff = new Date(today.getTime() - dateBirth.getTime());
            const age = diff.getUTCFullYear() - 1970;
            return age;
        },
        bckBtn() {
            if (this.currStep > 1) {
                this.regMsgTextErr = '';
                this.regBtnText = this.$t('register.next');
                this.currStep = this.currStep - 1;
            }
        },
        showPassword() {
            if (this.type === 'password') {
                this.type = 'text'
                this.btnText = 'fa fa-eye-slash'
            } else {
                this.type = 'password'
                this.btnText = 'fa fa-eye'
            }
        },
        showConfirmPassword() {
            if (this.confirmType === 'password') {
                this.confirmType = 'text'
                this.btnConfirmText = 'fa fa-eye-slash'
            } else {
                this.confirmType = 'password'
                this.btnConfirmText = 'fa fa-eye'
            }
        },
        register_first() {
            this.$v.$touch();
        },
        register() {
            this.regBusy = true;
            this.regBtnText = this.$t('register.signing_up');

            let formData = new FormData();
            formData.append('name', this.regFname);
            formData.append('email', this.regEmail);
            formData.append('password', this.regPassword);
            formData.append('phone', this.phoneData ? this.phoneData.formatInternational : this.regPhone);
            formData.append('user', 'guest');
            formData.append('recaptcha_token', this.recaptchaToken1);
            // Send consent checkbox
            formData.append('termsAccepted', this.termsAccepted ? 1 : 0);
            formData.append('ageConfirmed', this.ageConfirmed ? 1 : 0);
            formData.append('ip_address', this.userIp || '');
            if (this.profilePhoto) {
                formData.append('avatar', this.profilePhoto);
            }

            API.registerUser(
                formData,
                data => {
                    if (data.token) {
                        this.$refs.myModalRef.hide();
                        location.reload();
                    } else {
                        this.$swal({
                            icon: 'success',
                            type: 'success',
                            title: this.$t('alerts.success'),
                            text: data.message,
                        });

                        // Reset reCAPTCHA if backend rejects
                        if (this.$refs.recaptchaRef) {
                            this.$refs.recaptchaRef.reset();
                        }
                        this.recaptchaToken1 = null;
                    }
                    this.isDisabled = false;
                    this.regBusy = false;
                },
                err => {
                    this.$swal({
                        type: 'error',
                        icon: 'error',
                        title: this.$t('sweetalert.Oops'),
                        text: err.message,
                    });

                    // Reset reCAPTCHA on API error
                    if (this.$refs.recaptchaRef) {
                        this.$refs.recaptchaRef.reset();
                    }
                    this.recaptchaToken1 = null;

                    this.isDisabled = false;
                    this.regBusy = false;
                }
            );
        },
        onFileChange(event) {
            this.profilePhoto = event.target.files[0];
            if (this.profilePhoto) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.profilePhotoPreview = e.target.result;
                };
                reader.readAsDataURL(this.profilePhoto);
            }
        },
        regSingIn() {
            location.reload();
            window.location.href = "/login";
        },
        googleLogin() {
            window.location.href = "/redirect-google";
        },
        facebookLogin() {
            window.location.href = "/redirectfb";
        },
        instagramLogin() {
            window.location.href = "/redirectinsta";
        },
        switchVisibility() {
            this.passwordLogin = this.passwordLogin === "password" ? "text" : "password";
        },
        handleDateRangeUpdate(newRange) {
            if (newRange && newRange.startDate && newRange.endDate) {
                this.showAddDatesText = false;
                if (window.innerWidth <= 768) {
                    this.centerTabActive = false;
                }
            }
        },

        handleDateRangeApply() {
            if (this.dateRange && this.dateRange.startDate && this.dateRange.endDate) {
                this.showAddDatesText = false;
                if (window.innerWidth <= 768) {
                    this.centerTabActive = false;
                }
            }
        },
    }
};
</script>
